function me(e) {
  return (
    e !== null &&
    typeof e == "object" &&
    "constructor" in e &&
    e.constructor === Object
  );
}
function fe(e = {}, s = {}) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(s)
    .filter((i) => t.indexOf(i) < 0)
    .forEach((i) => {
      typeof e[i] > "u"
        ? (e[i] = s[i])
        : me(s[i]) &&
          me(e[i]) &&
          Object.keys(s[i]).length > 0 &&
          fe(e[i], s[i]);
    });
}
const Te = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: { blur() {}, nodeName: "" },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return { initEvent() {} };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      },
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: "",
  },
};
function N() {
  const e = typeof document < "u" ? document : {};
  return (fe(e, Te), e);
}
const ke = {
  document: Te,
  navigator: { userAgent: "" },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: "",
  },
  history: { replaceState() {}, pushState() {}, go() {}, back() {} },
  CustomEvent: function () {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      },
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(e) {
    return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
  },
  cancelAnimationFrame(e) {
    typeof setTimeout > "u" || clearTimeout(e);
  },
};
function V() {
  const e = typeof window < "u" ? window : {};
  return (fe(e, ke), e);
}
function R(e = "") {
  return e
    .trim()
    .split(" ")
    .filter((s) => !!s.trim());
}
function ze(e) {
  const s = e;
  Object.keys(s).forEach((t) => {
    try {
      s[t] = null;
    } catch {}
    try {
      delete s[t];
    } catch {}
  });
}
function ue(e, s = 0) {
  return setTimeout(e, s);
}
function Q() {
  return Date.now();
}
function De(e) {
  const s = V();
  let t;
  return (
    s.getComputedStyle && (t = s.getComputedStyle(e, null)),
    !t && e.currentStyle && (t = e.currentStyle),
    t || (t = e.style),
    t
  );
}
function Ge(e, s = "x") {
  const t = V();
  let i, r, n;
  const l = De(e);
  return (
    t.WebKitCSSMatrix
      ? ((r = l.transform || l.webkitTransform),
        r.split(",").length > 6 &&
          (r = r
            .split(", ")
            .map((o) => o.replace(",", "."))
            .join(", ")),
        (n = new t.WebKitCSSMatrix(r === "none" ? "" : r)))
      : ((n =
          l.MozTransform ||
          l.OTransform ||
          l.MsTransform ||
          l.msTransform ||
          l.transform ||
          l
            .getPropertyValue("transform")
            .replace("translate(", "matrix(1, 0, 0, 1,")),
        (i = n.toString().split(","))),
    s === "x" &&
      (t.WebKitCSSMatrix
        ? (r = n.m41)
        : i.length === 16
          ? (r = parseFloat(i[12]))
          : (r = parseFloat(i[4]))),
    s === "y" &&
      (t.WebKitCSSMatrix
        ? (r = n.m42)
        : i.length === 16
          ? (r = parseFloat(i[13]))
          : (r = parseFloat(i[5]))),
    r || 0
  );
}
function X(e) {
  return (
    typeof e == "object" &&
    e !== null &&
    e.constructor &&
    Object.prototype.toString.call(e).slice(8, -1) === "Object"
  );
}
function _e(e) {
  return typeof window < "u" && typeof window.HTMLElement < "u"
    ? e instanceof HTMLElement
    : e && (e.nodeType === 1 || e.nodeType === 11);
}
function F(...e) {
  const s = Object(e[0]);
  for (let t = 1; t < e.length; t += 1) {
    const i = e[t];
    if (i != null && !_e(i)) {
      const r = Object.keys(Object(i)).filter(
        (n) => n !== "__proto__" && n !== "constructor" && n !== "prototype",
      );
      for (let n = 0, l = r.length; n < l; n += 1) {
        const o = r[n],
          a = Object.getOwnPropertyDescriptor(i, o);
        a !== void 0 &&
          a.enumerable &&
          (X(s[o]) && X(i[o])
            ? i[o].__swiper__
              ? (s[o] = i[o])
              : F(s[o], i[o])
            : !X(s[o]) && X(i[o])
              ? ((s[o] = {}), i[o].__swiper__ ? (s[o] = i[o]) : F(s[o], i[o]))
              : (s[o] = i[o]));
      }
    }
  }
  return s;
}
function W(e, s, t) {
  e.style.setProperty(s, t);
}
function xe({ swiper: e, targetPosition: s, side: t }) {
  const i = V(),
    r = -e.translate;
  let n = null,
    l;
  const o = e.params.speed;
  ((e.wrapperEl.style.scrollSnapType = "none"),
    i.cancelAnimationFrame(e.cssModeFrameID));
  const a = s > r ? "next" : "prev",
    f = (c, g) => (a === "next" && c >= g) || (a === "prev" && c <= g),
    p = () => {
      ((l = new Date().getTime()), n === null && (n = l));
      const c = Math.max(Math.min((l - n) / o, 1), 0),
        g = 0.5 - Math.cos(c * Math.PI) / 2;
      let d = r + g * (s - r);
      if ((f(d, s) && (d = s), e.wrapperEl.scrollTo({ [t]: d }), f(d, s))) {
        ((e.wrapperEl.style.overflow = "hidden"),
          (e.wrapperEl.style.scrollSnapType = ""),
          setTimeout(() => {
            ((e.wrapperEl.style.overflow = ""),
              e.wrapperEl.scrollTo({ [t]: d }));
          }),
          i.cancelAnimationFrame(e.cssModeFrameID));
        return;
      }
      e.cssModeFrameID = i.requestAnimationFrame(p);
    };
  p();
}
function Ee(e) {
  return (
    e.querySelector(".swiper-slide-transform") ||
    (e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform")) ||
    e
  );
}
function H(e, s = "") {
  const t = V(),
    i = [...e.children];
  return (
    t.HTMLSlotElement &&
      e instanceof HTMLSlotElement &&
      i.push(...e.assignedElements()),
    s ? i.filter((r) => r.matches(s)) : i
  );
}
function Ve(e, s) {
  const t = [s];
  for (; t.length > 0; ) {
    const i = t.shift();
    if (e === i) return !0;
    t.push(
      ...i.children,
      ...(i.shadowRoot ? i.shadowRoot.children : []),
      ...(i.assignedElements ? i.assignedElements() : []),
    );
  }
}
function Be(e, s) {
  const t = V();
  let i = s.contains(e);
  return (
    !i &&
      t.HTMLSlotElement &&
      s instanceof HTMLSlotElement &&
      ((i = [...s.assignedElements()].includes(e)), i || (i = Ve(e, s))),
    i
  );
}
function Z(e) {
  try {
    console.warn(e);
    return;
  } catch {}
}
function U(e, s = []) {
  const t = document.createElement(e);
  return (t.classList.add(...(Array.isArray(s) ? s : R(s))), t);
}
function $e(e) {
  const s = V(),
    t = N(),
    i = e.getBoundingClientRect(),
    r = t.body,
    n = e.clientTop || r.clientTop || 0,
    l = e.clientLeft || r.clientLeft || 0,
    o = e === s ? s.scrollY : e.scrollTop,
    a = e === s ? s.scrollX : e.scrollLeft;
  return { top: i.top + o - n, left: i.left + a - l };
}
function Fe(e, s) {
  const t = [];
  for (; e.previousElementSibling; ) {
    const i = e.previousElementSibling;
    (s ? i.matches(s) && t.push(i) : t.push(i), (e = i));
  }
  return t;
}
function He(e, s) {
  const t = [];
  for (; e.nextElementSibling; ) {
    const i = e.nextElementSibling;
    (s ? i.matches(s) && t.push(i) : t.push(i), (e = i));
  }
  return t;
}
function j(e, s) {
  return V().getComputedStyle(e, null).getPropertyValue(s);
}
function J(e) {
  let s = e,
    t;
  if (s) {
    for (t = 0; (s = s.previousSibling) !== null; )
      s.nodeType === 1 && (t += 1);
    return t;
  }
}
function we(e, s) {
  const t = [];
  let i = e.parentElement;
  for (; i; )
    (s ? i.matches(s) && t.push(i) : t.push(i), (i = i.parentElement));
  return t;
}
function Ne(e, s) {
  function t(i) {
    i.target === e && (s.call(e, i), e.removeEventListener("transitionend", t));
  }
  s && e.addEventListener("transitionend", t);
}
function le(e, s, t) {
  const i = V();
  return t
    ? e[s === "width" ? "offsetWidth" : "offsetHeight"] +
        parseFloat(
          i
            .getComputedStyle(e, null)
            .getPropertyValue(s === "width" ? "margin-right" : "margin-top"),
        ) +
        parseFloat(
          i
            .getComputedStyle(e, null)
            .getPropertyValue(s === "width" ? "margin-left" : "margin-bottom"),
        )
    : e.offsetWidth;
}
function D(e) {
  return (Array.isArray(e) ? e : [e]).filter((s) => !!s);
}
function oe(e, s = "") {
  typeof trustedTypes < "u"
    ? (e.innerHTML = trustedTypes
        .createPolicy("html", { createHTML: (t) => t })
        .createHTML(s))
    : (e.innerHTML = s);
}
let ee;
function qe() {
  const e = V(),
    s = N();
  return {
    smoothScroll:
      s.documentElement &&
      s.documentElement.style &&
      "scrollBehavior" in s.documentElement.style,
    touch: !!(
      "ontouchstart" in e ||
      (e.DocumentTouch && s instanceof e.DocumentTouch)
    ),
  };
}
function Ce() {
  return (ee || (ee = qe()), ee);
}
let te;
function Re({ userAgent: e } = {}) {
  const s = Ce(),
    t = V(),
    i = t.navigator.platform,
    r = e || t.navigator.userAgent,
    n = { ios: !1, android: !1 },
    l = t.screen.width,
    o = t.screen.height,
    a = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let f = r.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
  const p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
    c = !f && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    g = i === "Win32";
  let d = i === "MacIntel";
  const m = [
    "1024x1366",
    "1366x1024",
    "834x1194",
    "1194x834",
    "834x1112",
    "1112x834",
    "768x1024",
    "1024x768",
    "820x1180",
    "1180x820",
    "810x1080",
    "1080x810",
  ];
  return (
    !f &&
      d &&
      s.touch &&
      m.indexOf(`${l}x${o}`) >= 0 &&
      ((f = r.match(/(Version)\/([\d.]+)/)),
      f || (f = [0, 1, "13_0_0"]),
      (d = !1)),
    a && !g && ((n.os = "android"), (n.android = !0)),
    (f || c || p) && ((n.os = "ios"), (n.ios = !0)),
    n
  );
}
function Pe(e = {}) {
  return (te || (te = Re(e)), te);
}
let se;
function je() {
  const e = V(),
    s = Pe();
  let t = !1;
  function i() {
    const o = e.navigator.userAgent.toLowerCase();
    return (
      o.indexOf("safari") >= 0 &&
      o.indexOf("chrome") < 0 &&
      o.indexOf("android") < 0
    );
  }
  if (i()) {
    const o = String(e.navigator.userAgent);
    if (o.includes("Version/")) {
      const [a, f] = o
        .split("Version/")[1]
        .split(" ")[0]
        .split(".")
        .map((p) => Number(p));
      t = a < 16 || (a === 16 && f < 2);
    }
  }
  const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      e.navigator.userAgent,
    ),
    n = i(),
    l = n || (r && s.ios);
  return {
    isSafari: t || n,
    needPerspectiveFix: t,
    need3dFix: l,
    isWebView: r,
  };
}
function Le() {
  return (se || (se = je()), se);
}
function We({ swiper: e, on: s, emit: t }) {
  const i = V();
  let r = null,
    n = null;
  const l = () => {
      !e || e.destroyed || !e.initialized || (t("beforeResize"), t("resize"));
    },
    o = () => {
      !e ||
        e.destroyed ||
        !e.initialized ||
        ((r = new ResizeObserver((p) => {
          n = i.requestAnimationFrame(() => {
            const { width: c, height: g } = e;
            let d = c,
              m = g;
            (p.forEach(({ contentBoxSize: b, contentRect: y, target: u }) => {
              (u && u !== e.el) ||
                ((d = y ? y.width : (b[0] || b).inlineSize),
                (m = y ? y.height : (b[0] || b).blockSize));
            }),
              (d !== c || m !== g) && l());
          });
        })),
        r.observe(e.el));
    },
    a = () => {
      (n && i.cancelAnimationFrame(n),
        r && r.unobserve && e.el && (r.unobserve(e.el), (r = null)));
    },
    f = () => {
      !e || e.destroyed || !e.initialized || t("orientationchange");
    };
  (s("init", () => {
    if (e.params.resizeObserver && typeof i.ResizeObserver < "u") {
      o();
      return;
    }
    (i.addEventListener("resize", l),
      i.addEventListener("orientationchange", f));
  }),
    s("destroy", () => {
      (a(),
        i.removeEventListener("resize", l),
        i.removeEventListener("orientationchange", f));
    }));
}
function Ye({ swiper: e, extendParams: s, on: t, emit: i }) {
  const r = [],
    n = V(),
    l = (f, p = {}) => {
      const c = n.MutationObserver || n.WebkitMutationObserver,
        g = new c((d) => {
          if (e.__preventObserver__) return;
          if (d.length === 1) {
            i("observerUpdate", d[0]);
            return;
          }
          const m = function () {
            i("observerUpdate", d[0]);
          };
          n.requestAnimationFrame
            ? n.requestAnimationFrame(m)
            : n.setTimeout(m, 0);
        });
      (g.observe(f, {
        attributes: typeof p.attributes > "u" ? !0 : p.attributes,
        childList: e.isElement || (typeof p.childList > "u" ? !0 : p).childList,
        characterData: typeof p.characterData > "u" ? !0 : p.characterData,
      }),
        r.push(g));
    },
    o = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const f = we(e.hostEl);
          for (let p = 0; p < f.length; p += 1) l(f[p]);
        }
        (l(e.hostEl, { childList: e.params.observeSlideChildren }),
          l(e.wrapperEl, { attributes: !1 }));
      }
    },
    a = () => {
      (r.forEach((f) => {
        f.disconnect();
      }),
        r.splice(0, r.length));
    };
  (s({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
    t("init", o),
    t("destroy", a));
}
var Xe = {
  on(e, s, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof s != "function") return i;
    const r = t ? "unshift" : "push";
    return (
      e.split(" ").forEach((n) => {
        (i.eventsListeners[n] || (i.eventsListeners[n] = []),
          i.eventsListeners[n][r](s));
      }),
      i
    );
  },
  once(e, s, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof s != "function") return i;
    function r(...n) {
      (i.off(e, r), r.__emitterProxy && delete r.__emitterProxy, s.apply(i, n));
    }
    return ((r.__emitterProxy = s), i.on(e, r, t));
  },
  onAny(e, s) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof e != "function") return t;
    const i = s ? "unshift" : "push";
    return (
      t.eventsAnyListeners.indexOf(e) < 0 && t.eventsAnyListeners[i](e),
      t
    );
  },
  offAny(e) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || !s.eventsAnyListeners) return s;
    const t = s.eventsAnyListeners.indexOf(e);
    return (t >= 0 && s.eventsAnyListeners.splice(t, 1), s);
  },
  off(e, s) {
    const t = this;
    return (
      !t.eventsListeners ||
        t.destroyed ||
        !t.eventsListeners ||
        e.split(" ").forEach((i) => {
          typeof s > "u"
            ? (t.eventsListeners[i] = [])
            : t.eventsListeners[i] &&
              t.eventsListeners[i].forEach((r, n) => {
                (r === s || (r.__emitterProxy && r.__emitterProxy === s)) &&
                  t.eventsListeners[i].splice(n, 1);
              });
        }),
      t
    );
  },
  emit(...e) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || !s.eventsListeners) return s;
    let t, i, r;
    return (
      typeof e[0] == "string" || Array.isArray(e[0])
        ? ((t = e[0]), (i = e.slice(1, e.length)), (r = s))
        : ((t = e[0].events), (i = e[0].data), (r = e[0].context || s)),
      i.unshift(r),
      (Array.isArray(t) ? t : t.split(" ")).forEach((l) => {
        (s.eventsAnyListeners &&
          s.eventsAnyListeners.length &&
          s.eventsAnyListeners.forEach((o) => {
            o.apply(r, [l, ...i]);
          }),
          s.eventsListeners &&
            s.eventsListeners[l] &&
            s.eventsListeners[l].forEach((o) => {
              o.apply(r, i);
            }));
      }),
      s
    );
  },
};
function Ue() {
  const e = this;
  let s, t;
  const i = e.el;
  (typeof e.params.width < "u" && e.params.width !== null
    ? (s = e.params.width)
    : (s = i.clientWidth),
    typeof e.params.height < "u" && e.params.height !== null
      ? (t = e.params.height)
      : (t = i.clientHeight),
    !((s === 0 && e.isHorizontal()) || (t === 0 && e.isVertical())) &&
      ((s =
        s -
        parseInt(j(i, "padding-left") || 0, 10) -
        parseInt(j(i, "padding-right") || 0, 10)),
      (t =
        t -
        parseInt(j(i, "padding-top") || 0, 10) -
        parseInt(j(i, "padding-bottom") || 0, 10)),
      Number.isNaN(s) && (s = 0),
      Number.isNaN(t) && (t = 0),
      Object.assign(e, {
        width: s,
        height: t,
        size: e.isHorizontal() ? s : t,
      })));
}
function Ke() {
  const e = this;
  function s(P, S) {
    return parseFloat(P.getPropertyValue(e.getDirectionLabel(S)) || 0);
  }
  const t = e.params,
    { wrapperEl: i, slidesEl: r, rtlTranslate: n, wrongRTL: l } = e,
    o = e.virtual && t.virtual.enabled,
    a = o ? e.virtual.slides.length : e.slides.length,
    f = H(r, `.${e.params.slideClass}, swiper-slide`),
    p = o ? e.virtual.slides.length : f.length;
  let c = [];
  const g = [],
    d = [];
  let m = t.slidesOffsetBefore;
  typeof m == "function" && (m = t.slidesOffsetBefore.call(e));
  let b = t.slidesOffsetAfter;
  typeof b == "function" && (b = t.slidesOffsetAfter.call(e));
  const y = e.snapGrid.length,
    u = e.slidesGrid.length,
    h = e.size - m - b;
  let v = t.spaceBetween,
    x = -m,
    L = 0,
    A = 0;
  if (typeof h > "u") return;
  (typeof v == "string" && v.indexOf("%") >= 0
    ? (v = (parseFloat(v.replace("%", "")) / 100) * h)
    : typeof v == "string" && (v = parseFloat(v)),
    (e.virtualSize = -v - m - b),
    f.forEach((P) => {
      (n ? (P.style.marginLeft = "") : (P.style.marginRight = ""),
        (P.style.marginBottom = ""),
        (P.style.marginTop = ""));
    }),
    t.centeredSlides &&
      t.cssMode &&
      (W(i, "--swiper-centered-offset-before", ""),
      W(i, "--swiper-centered-offset-after", "")),
    t.cssMode &&
      (W(i, "--swiper-slides-offset-before", `${m}px`),
      W(i, "--swiper-slides-offset-after", `${b}px`)));
  const O = t.grid && t.grid.rows > 1 && e.grid;
  O ? e.grid.initSlides(f) : e.grid && e.grid.unsetSlides();
  let E;
  const k =
    t.slidesPerView === "auto" &&
    t.breakpoints &&
    Object.keys(t.breakpoints).filter(
      (P) => typeof t.breakpoints[P].slidesPerView < "u",
    ).length > 0;
  for (let P = 0; P < p; P += 1) {
    E = 0;
    const S = f[P];
    if (
      !(S && (O && e.grid.updateSlide(P, S, f), j(S, "display") === "none"))
    ) {
      if (o && t.slidesPerView === "auto")
        (t.virtual.slidesPerViewAutoSlideSize &&
          (E = t.virtual.slidesPerViewAutoSlideSize),
          E &&
            S &&
            (t.roundLengths && (E = Math.floor(E)),
            (S.style[e.getDirectionLabel("width")] = `${E}px`)));
      else if (t.slidesPerView === "auto") {
        k && (S.style[e.getDirectionLabel("width")] = "");
        const T = getComputedStyle(S),
          w = S.style.transform,
          C = S.style.webkitTransform;
        if (
          (w && (S.style.transform = "none"),
          C && (S.style.webkitTransform = "none"),
          t.roundLengths)
        )
          E = e.isHorizontal() ? le(S, "width", !0) : le(S, "height", !0);
        else {
          const I = s(T, "width"),
            z = s(T, "padding-left"),
            _ = s(T, "padding-right"),
            M = s(T, "margin-left"),
            G = s(T, "margin-right"),
            B = T.getPropertyValue("box-sizing");
          if (B && B === "border-box") E = I + M + G;
          else {
            const { clientWidth: q, offsetWidth: Oe } = S;
            E = I + z + _ + M + G + (Oe - q);
          }
        }
        (w && (S.style.transform = w),
          C && (S.style.webkitTransform = C),
          t.roundLengths && (E = Math.floor(E)));
      } else
        ((E = (h - (t.slidesPerView - 1) * v) / t.slidesPerView),
          t.roundLengths && (E = Math.floor(E)),
          S && (S.style[e.getDirectionLabel("width")] = `${E}px`));
      (S && (S.swiperSlideSize = E),
        d.push(E),
        t.centeredSlides
          ? ((x = x + E / 2 + L / 2 + v),
            L === 0 && P !== 0 && (x = x - h / 2 - v),
            P === 0 && (x = x - h / 2 - v),
            Math.abs(x) < 1 / 1e3 && (x = 0),
            t.roundLengths && (x = Math.floor(x)),
            A % t.slidesPerGroup === 0 && c.push(x),
            g.push(x))
          : (t.roundLengths && (x = Math.floor(x)),
            (A - Math.min(e.params.slidesPerGroupSkip, A)) %
              e.params.slidesPerGroup ===
              0 && c.push(x),
            g.push(x),
            (x = x + E + v)),
        (e.virtualSize += E + v),
        (L = E),
        (A += 1));
    }
  }
  if (
    ((e.virtualSize = Math.max(e.virtualSize, h) + b),
    n &&
      l &&
      (t.effect === "slide" || t.effect === "coverflow") &&
      (i.style.width = `${e.virtualSize + v}px`),
    t.setWrapperSize &&
      (i.style[e.getDirectionLabel("width")] = `${e.virtualSize + v}px`),
    O && e.grid.updateWrapperSize(E, c),
    !t.centeredSlides)
  ) {
    const P = t.slidesPerView !== "auto" && t.slidesPerView % 1 !== 0,
      S = t.snapToSlideEdge && !t.loop && (t.slidesPerView === "auto" || P);
    let T = c.length;
    if (S) {
      let C;
      if (t.slidesPerView === "auto") {
        C = 1;
        let I = 0;
        for (
          let z = d.length - 1;
          z >= 0 && ((I += d[z] + (z < d.length - 1 ? v : 0)), I <= h);
          z -= 1
        )
          C = d.length - z;
      } else C = Math.floor(t.slidesPerView);
      T = Math.max(p - C, 0);
    }
    const w = [];
    for (let C = 0; C < c.length; C += 1) {
      let I = c[C];
      (t.roundLengths && (I = Math.floor(I)),
        S ? C <= T && w.push(I) : c[C] <= e.virtualSize - h && w.push(I));
    }
    ((c = w),
      Math.floor(e.virtualSize - h) - Math.floor(c[c.length - 1]) > 1 &&
        (S || c.push(e.virtualSize - h)));
  }
  if (o && t.loop) {
    const P = d[0] + v;
    if (t.slidesPerGroup > 1) {
      const S = Math.ceil(
          (e.virtual.slidesBefore + e.virtual.slidesAfter) / t.slidesPerGroup,
        ),
        T = P * t.slidesPerGroup;
      for (let w = 0; w < S; w += 1) c.push(c[c.length - 1] + T);
    }
    for (let S = 0; S < e.virtual.slidesBefore + e.virtual.slidesAfter; S += 1)
      (t.slidesPerGroup === 1 && c.push(c[c.length - 1] + P),
        g.push(g[g.length - 1] + P),
        (e.virtualSize += P));
  }
  if ((c.length === 0 && (c = [0]), v !== 0)) {
    const P =
      e.isHorizontal() && n ? "marginLeft" : e.getDirectionLabel("marginRight");
    f.filter((S, T) =>
      !t.cssMode || t.loop ? !0 : T !== f.length - 1,
    ).forEach((S) => {
      S.style[P] = `${v}px`;
    });
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let P = 0;
    (d.forEach((T) => {
      P += T + (v || 0);
    }),
      (P -= v));
    const S = P > h ? P - h : 0;
    c = c.map((T) => (T <= 0 ? -m : T > S ? S + b : T));
  }
  if (t.centerInsufficientSlides) {
    let P = 0;
    if (
      (d.forEach((S) => {
        P += S + (v || 0);
      }),
      (P -= v),
      P < h)
    ) {
      const S = (h - P) / 2;
      (c.forEach((T, w) => {
        c[w] = T - S;
      }),
        g.forEach((T, w) => {
          g[w] = T + S;
        }));
    }
  }
  if (
    (Object.assign(e, {
      slides: f,
      snapGrid: c,
      slidesGrid: g,
      slidesSizesGrid: d,
    }),
    t.centeredSlides && t.cssMode && !t.centeredSlidesBounds)
  ) {
    (W(i, "--swiper-centered-offset-before", `${-c[0]}px`),
      W(
        i,
        "--swiper-centered-offset-after",
        `${e.size / 2 - d[d.length - 1] / 2}px`,
      ));
    const P = -e.snapGrid[0],
      S = -e.slidesGrid[0];
    ((e.snapGrid = e.snapGrid.map((T) => T + P)),
      (e.slidesGrid = e.slidesGrid.map((T) => T + S)));
  }
  if (
    (p !== a && e.emit("slidesLengthChange"),
    c.length !== y &&
      (e.params.watchOverflow && e.checkOverflow(),
      e.emit("snapGridLengthChange")),
    g.length !== u && e.emit("slidesGridLengthChange"),
    t.watchSlidesProgress && e.updateSlidesOffset(),
    e.emit("slidesUpdated"),
    !o && !t.cssMode && (t.effect === "slide" || t.effect === "fade"))
  ) {
    const P = `${t.containerModifierClass}backface-hidden`,
      S = e.el.classList.contains(P);
    p <= t.maxBackfaceHiddenSlides
      ? S || e.el.classList.add(P)
      : S && e.el.classList.remove(P);
  }
}
function Qe(e) {
  const s = this,
    t = [],
    i = s.virtual && s.params.virtual.enabled;
  let r = 0,
    n;
  typeof e == "number"
    ? s.setTransition(e)
    : e === !0 && s.setTransition(s.params.speed);
  const l = (o) => (i ? s.slides[s.getSlideIndexByData(o)] : s.slides[o]);
  if (s.params.slidesPerView !== "auto" && s.params.slidesPerView > 1)
    if (s.params.centeredSlides)
      (s.visibleSlides || []).forEach((o) => {
        t.push(o);
      });
    else
      for (n = 0; n < Math.ceil(s.params.slidesPerView); n += 1) {
        const o = s.activeIndex + n;
        if (o > s.slides.length && !i) break;
        t.push(l(o));
      }
  else t.push(l(s.activeIndex));
  for (n = 0; n < t.length; n += 1)
    if (typeof t[n] < "u") {
      const o = t[n].offsetHeight;
      r = o > r ? o : r;
    }
  (r || r === 0) && (s.wrapperEl.style.height = `${r}px`);
}
function Ze() {
  const e = this,
    s = e.slides,
    t = e.isElement
      ? e.isHorizontal()
        ? e.wrapperEl.offsetLeft
        : e.wrapperEl.offsetTop
      : 0;
  for (let i = 0; i < s.length; i += 1)
    s[i].swiperSlideOffset =
      (e.isHorizontal() ? s[i].offsetLeft : s[i].offsetTop) -
      t -
      e.cssOverflowAdjustment();
}
const he = (e, s, t) => {
  s && !e.classList.contains(t)
    ? e.classList.add(t)
    : !s && e.classList.contains(t) && e.classList.remove(t);
};
function Je(e = (this && this.translate) || 0) {
  const s = this,
    t = s.params,
    { slides: i, rtlTranslate: r, snapGrid: n } = s;
  if (i.length === 0) return;
  typeof i[0].swiperSlideOffset > "u" && s.updateSlidesOffset();
  let l = -e;
  (r && (l = e), (s.visibleSlidesIndexes = []), (s.visibleSlides = []));
  let o = t.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0
    ? (o = (parseFloat(o.replace("%", "")) / 100) * s.size)
    : typeof o == "string" && (o = parseFloat(o));
  for (let a = 0; a < i.length; a += 1) {
    const f = i[a];
    let p = f.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (p -= i[0].swiperSlideOffset);
    const c =
        (l + (t.centeredSlides ? s.minTranslate() : 0) - p) /
        (f.swiperSlideSize + o),
      g =
        (l - n[0] + (t.centeredSlides ? s.minTranslate() : 0) - p) /
        (f.swiperSlideSize + o),
      d = -(l - p),
      m = d + s.slidesSizesGrid[a],
      b = d >= 0 && d <= s.size - s.slidesSizesGrid[a],
      y =
        (d >= 0 && d < s.size - 1) ||
        (m > 1 && m <= s.size) ||
        (d <= 0 && m >= s.size);
    (y && (s.visibleSlides.push(f), s.visibleSlidesIndexes.push(a)),
      he(f, y, t.slideVisibleClass),
      he(f, b, t.slideFullyVisibleClass),
      (f.progress = r ? -c : c),
      (f.originalProgress = r ? -g : g));
  }
}
function et(e) {
  const s = this;
  if (typeof e > "u") {
    const p = s.rtlTranslate ? -1 : 1;
    e = (s && s.translate && s.translate * p) || 0;
  }
  const t = s.params,
    i = s.maxTranslate() - s.minTranslate();
  let { progress: r, isBeginning: n, isEnd: l, progressLoop: o } = s;
  const a = n,
    f = l;
  if (i === 0) ((r = 0), (n = !0), (l = !0));
  else {
    r = (e - s.minTranslate()) / i;
    const p = Math.abs(e - s.minTranslate()) < 1,
      c = Math.abs(e - s.maxTranslate()) < 1;
    ((n = p || r <= 0), (l = c || r >= 1), p && (r = 0), c && (r = 1));
  }
  if (t.loop) {
    const p = s.getSlideIndexByData(0),
      c = s.getSlideIndexByData(s.slides.length - 1),
      g = s.slidesGrid[p],
      d = s.slidesGrid[c],
      m = s.slidesGrid[s.slidesGrid.length - 1],
      b = Math.abs(e);
    (b >= g ? (o = (b - g) / m) : (o = (b + m - d) / m), o > 1 && (o -= 1));
  }
  (Object.assign(s, { progress: r, progressLoop: o, isBeginning: n, isEnd: l }),
    (t.watchSlidesProgress || (t.centeredSlides && t.autoHeight)) &&
      s.updateSlidesProgress(e),
    n && !a && s.emit("reachBeginning toEdge"),
    l && !f && s.emit("reachEnd toEdge"),
    ((a && !n) || (f && !l)) && s.emit("fromEdge"),
    s.emit("progress", r));
}
const ie = (e, s, t) => {
  s && !e.classList.contains(t)
    ? e.classList.add(t)
    : !s && e.classList.contains(t) && e.classList.remove(t);
};
function tt() {
  const e = this,
    { slides: s, params: t, slidesEl: i, activeIndex: r } = e,
    n = e.virtual && t.virtual.enabled,
    l = e.grid && t.grid && t.grid.rows > 1,
    o = (c) => H(i, `.${t.slideClass}${c}, swiper-slide${c}`)[0];
  let a, f, p;
  if (n)
    if (t.loop) {
      let c = r - e.virtual.slidesBefore;
      (c < 0 && (c = e.virtual.slides.length + c),
        c >= e.virtual.slides.length && (c -= e.virtual.slides.length),
        (a = o(`[data-swiper-slide-index="${c}"]`)));
    } else a = o(`[data-swiper-slide-index="${r}"]`);
  else
    l
      ? ((a = s.find((c) => c.column === r)),
        (p = s.find((c) => c.column === r + 1)),
        (f = s.find((c) => c.column === r - 1)))
      : (a = s[r]);
  (a &&
    (l ||
      ((p = He(a, `.${t.slideClass}, swiper-slide`)[0]),
      t.loop && !p && (p = s[0]),
      (f = Fe(a, `.${t.slideClass}, swiper-slide`)[0]),
      t.loop && !f === 0 && (f = s[s.length - 1]))),
    s.forEach((c) => {
      (ie(c, c === a, t.slideActiveClass),
        ie(c, c === p, t.slideNextClass),
        ie(c, c === f, t.slidePrevClass));
    }),
    e.emitSlidesClasses());
}
const K = (e, s) => {
    if (!e || e.destroyed || !e.params) return;
    const t = () => (e.isElement ? "swiper-slide" : `.${e.params.slideClass}`),
      i = s.closest(t());
    if (i) {
      let r = i.querySelector(`.${e.params.lazyPreloaderClass}`);
      (!r &&
        e.isElement &&
        (i.shadowRoot
          ? (r = i.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`))
          : requestAnimationFrame(() => {
              i.shadowRoot &&
                ((r = i.shadowRoot.querySelector(
                  `.${e.params.lazyPreloaderClass}`,
                )),
                r && !r.lazyPreloaderManaged && r.remove());
            })),
        r && !r.lazyPreloaderManaged && r.remove());
    }
  },
  ne = (e, s) => {
    if (!e.slides[s]) return;
    const t = e.slides[s].querySelector('[loading="lazy"]');
    t && t.removeAttribute("loading");
  },
  de = (e) => {
    if (!e || e.destroyed || !e.params) return;
    let s = e.params.lazyPreloadPrevNext;
    const t = e.slides.length;
    if (!t || !s || s < 0) return;
    s = Math.min(s, t);
    const i =
        e.params.slidesPerView === "auto"
          ? e.slidesPerViewDynamic()
          : Math.ceil(e.params.slidesPerView),
      r = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
      const l = r,
        o = [l - s];
      (o.push(...Array.from({ length: s }).map((a, f) => l + i + f)),
        e.slides.forEach((a, f) => {
          o.includes(a.column) && ne(e, f);
        }));
      return;
    }
    const n = r + i - 1;
    if (e.params.rewind || e.params.loop)
      for (let l = r - s; l <= n + s; l += 1) {
        const o = ((l % t) + t) % t;
        (o < r || o > n) && ne(e, o);
      }
    else
      for (let l = Math.max(r - s, 0); l <= Math.min(n + s, t - 1); l += 1)
        l !== r && (l > n || l < r) && ne(e, l);
  };
function st(e) {
  const { slidesGrid: s, params: t } = e,
    i = e.rtlTranslate ? e.translate : -e.translate;
  let r;
  for (let n = 0; n < s.length; n += 1)
    typeof s[n + 1] < "u"
      ? i >= s[n] && i < s[n + 1] - (s[n + 1] - s[n]) / 2
        ? (r = n)
        : i >= s[n] && i < s[n + 1] && (r = n + 1)
      : i >= s[n] && (r = n);
  return (t.normalizeSlideIndex && (r < 0 || typeof r > "u") && (r = 0), r);
}
function it(e) {
  const s = this,
    t = s.rtlTranslate ? s.translate : -s.translate,
    { snapGrid: i, params: r, activeIndex: n, realIndex: l, snapIndex: o } = s;
  let a = e,
    f;
  const p = (d) => {
    let m = d - s.virtual.slidesBefore;
    return (
      m < 0 && (m = s.virtual.slides.length + m),
      m >= s.virtual.slides.length && (m -= s.virtual.slides.length),
      m
    );
  };
  if ((typeof a > "u" && (a = st(s)), i.indexOf(t) >= 0)) f = i.indexOf(t);
  else {
    const d = Math.min(r.slidesPerGroupSkip, a);
    f = d + Math.floor((a - d) / r.slidesPerGroup);
  }
  if ((f >= i.length && (f = i.length - 1), a === n && !s.params.loop)) {
    f !== o && ((s.snapIndex = f), s.emit("snapIndexChange"));
    return;
  }
  if (a === n && s.params.loop && s.virtual && s.params.virtual.enabled) {
    s.realIndex = p(a);
    return;
  }
  const c = s.grid && r.grid && r.grid.rows > 1;
  let g;
  if (s.virtual && r.virtual.enabled) r.loop ? (g = p(a)) : (g = a);
  else if (c) {
    const d = s.slides.find((b) => b.column === a);
    let m = parseInt(d.getAttribute("data-swiper-slide-index"), 10);
    (Number.isNaN(m) && (m = Math.max(s.slides.indexOf(d), 0)),
      (g = Math.floor(m / r.grid.rows)));
  } else if (s.slides[a]) {
    const d = s.slides[a].getAttribute("data-swiper-slide-index");
    d ? (g = parseInt(d, 10)) : (g = a);
  } else g = a;
  (Object.assign(s, {
    previousSnapIndex: o,
    snapIndex: f,
    previousRealIndex: l,
    realIndex: g,
    previousIndex: n,
    activeIndex: a,
  }),
    s.initialized && de(s),
    s.emit("activeIndexChange"),
    s.emit("snapIndexChange"),
    (s.initialized || s.params.runCallbacksOnInit) &&
      (l !== g && s.emit("realIndexChange"), s.emit("slideChange")));
}
function nt(e, s) {
  const t = this,
    i = t.params;
  let r = e.closest(`.${i.slideClass}, swiper-slide`);
  !r &&
    t.isElement &&
    s &&
    s.length > 1 &&
    s.includes(e) &&
    [...s.slice(s.indexOf(e) + 1, s.length)].forEach((o) => {
      !r && o.matches && o.matches(`.${i.slideClass}, swiper-slide`) && (r = o);
    });
  let n = !1,
    l;
  if (r) {
    for (let o = 0; o < t.slides.length; o += 1)
      if (t.slides[o] === r) {
        ((n = !0), (l = o));
        break;
      }
  }
  if (r && n)
    ((t.clickedSlide = r),
      t.virtual && t.params.virtual.enabled
        ? (t.clickedIndex = parseInt(
            r.getAttribute("data-swiper-slide-index"),
            10,
          ))
        : (t.clickedIndex = l));
  else {
    ((t.clickedSlide = void 0), (t.clickedIndex = void 0));
    return;
  }
  i.slideToClickedSlide &&
    t.clickedIndex !== void 0 &&
    t.clickedIndex !== t.activeIndex &&
    t.slideToClickedSlide();
}
var rt = {
  updateSize: Ue,
  updateSlides: Ke,
  updateAutoHeight: Qe,
  updateSlidesOffset: Ze,
  updateSlidesProgress: Je,
  updateProgress: et,
  updateSlidesClasses: tt,
  updateActiveIndex: it,
  updateClickedSlide: nt,
};
function at(e = this.isHorizontal() ? "x" : "y") {
  const s = this,
    { params: t, rtlTranslate: i, translate: r, wrapperEl: n } = s;
  if (t.virtualTranslate) return i ? -r : r;
  if (t.cssMode) return r;
  let l = Ge(n, e);
  return ((l += s.cssOverflowAdjustment()), i && (l = -l), l || 0);
}
function lt(e, s) {
  const t = this,
    { rtlTranslate: i, params: r, wrapperEl: n, progress: l } = t;
  let o = 0,
    a = 0;
  const f = 0;
  (t.isHorizontal() ? (o = i ? -e : e) : (a = e),
    r.roundLengths && ((o = Math.floor(o)), (a = Math.floor(a))),
    (t.previousTranslate = t.translate),
    (t.translate = t.isHorizontal() ? o : a),
    r.cssMode
      ? (n[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal()
          ? -o
          : -a)
      : r.virtualTranslate ||
        (t.isHorizontal()
          ? (o -= t.cssOverflowAdjustment())
          : (a -= t.cssOverflowAdjustment()),
        (n.style.transform = `translate3d(${o}px, ${a}px, ${f}px)`)));
  let p;
  const c = t.maxTranslate() - t.minTranslate();
  (c === 0 ? (p = 0) : (p = (e - t.minTranslate()) / c),
    p !== l && t.updateProgress(e),
    t.emit("setTranslate", t.translate, s));
}
function ot() {
  return -this.snapGrid[0];
}
function dt() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function ct(e = 0, s = this.params.speed, t = !0, i = !0, r) {
  const n = this,
    { params: l, wrapperEl: o } = n;
  if (n.animating && l.preventInteractionOnTransition) return !1;
  const a = n.minTranslate(),
    f = n.maxTranslate();
  let p;
  if (
    (i && e > a ? (p = a) : i && e < f ? (p = f) : (p = e),
    n.updateProgress(p),
    l.cssMode)
  ) {
    const c = n.isHorizontal();
    if (s === 0) o[c ? "scrollLeft" : "scrollTop"] = -p;
    else {
      if (!n.support.smoothScroll)
        return (
          xe({ swiper: n, targetPosition: -p, side: c ? "left" : "top" }),
          !0
        );
      o.scrollTo({ [c ? "left" : "top"]: -p, behavior: "smooth" });
    }
    return !0;
  }
  return (
    s === 0
      ? (n.setTransition(0),
        n.setTranslate(p),
        t && (n.emit("beforeTransitionStart", s, r), n.emit("transitionEnd")))
      : (n.setTransition(s),
        n.setTranslate(p),
        t && (n.emit("beforeTransitionStart", s, r), n.emit("transitionStart")),
        n.animating ||
          ((n.animating = !0),
          n.onTranslateToWrapperTransitionEnd ||
            (n.onTranslateToWrapperTransitionEnd = function (g) {
              !n ||
                n.destroyed ||
                (g.target === this &&
                  (n.wrapperEl.removeEventListener(
                    "transitionend",
                    n.onTranslateToWrapperTransitionEnd,
                  ),
                  (n.onTranslateToWrapperTransitionEnd = null),
                  delete n.onTranslateToWrapperTransitionEnd,
                  (n.animating = !1),
                  t && n.emit("transitionEnd")));
            }),
          n.wrapperEl.addEventListener(
            "transitionend",
            n.onTranslateToWrapperTransitionEnd,
          ))),
    !0
  );
}
var ft = {
  getTranslate: at,
  setTranslate: lt,
  minTranslate: ot,
  maxTranslate: dt,
  translateTo: ct,
};
function ut(e, s) {
  const t = this;
  (t.params.cssMode ||
    ((t.wrapperEl.style.transitionDuration = `${e}ms`),
    (t.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : "")),
    t.emit("setTransition", e, s));
}
function Me({ swiper: e, runCallbacks: s, direction: t, step: i }) {
  const { activeIndex: r, previousIndex: n } = e;
  let l = t;
  (l || (r > n ? (l = "next") : r < n ? (l = "prev") : (l = "reset")),
    e.emit(`transition${i}`),
    s && l === "reset"
      ? e.emit(`slideResetTransition${i}`)
      : s &&
        r !== n &&
        (e.emit(`slideChangeTransition${i}`),
        l === "next"
          ? e.emit(`slideNextTransition${i}`)
          : e.emit(`slidePrevTransition${i}`)));
}
function pt(e = !0, s) {
  const t = this,
    { params: i } = t;
  i.cssMode ||
    (i.autoHeight && t.updateAutoHeight(),
    Me({ swiper: t, runCallbacks: e, direction: s, step: "Start" }));
}
function mt(e = !0, s) {
  const t = this,
    { params: i } = t;
  ((t.animating = !1),
    !i.cssMode &&
      (t.setTransition(0),
      Me({ swiper: t, runCallbacks: e, direction: s, step: "End" })));
}
var ht = { setTransition: ut, transitionStart: pt, transitionEnd: mt };
function gt(e = 0, s, t = !0, i, r) {
  typeof e == "string" && (e = parseInt(e, 10));
  const n = this;
  let l = e;
  l < 0 && (l = 0);
  const {
    params: o,
    snapGrid: a,
    slidesGrid: f,
    previousIndex: p,
    activeIndex: c,
    rtlTranslate: g,
    wrapperEl: d,
    enabled: m,
  } = n;
  if (
    (!m && !i && !r) ||
    n.destroyed ||
    (n.animating && o.preventInteractionOnTransition)
  )
    return !1;
  typeof s > "u" && (s = n.params.speed);
  const b = Math.min(n.params.slidesPerGroupSkip, l);
  let y = b + Math.floor((l - b) / n.params.slidesPerGroup);
  y >= a.length && (y = a.length - 1);
  const u = -a[y];
  if (o.normalizeSlideIndex)
    for (let O = 0; O < f.length; O += 1) {
      const E = -Math.floor(u * 100),
        k = Math.floor(f[O] * 100),
        P = Math.floor(f[O + 1] * 100);
      typeof f[O + 1] < "u"
        ? E >= k && E < P - (P - k) / 2
          ? (l = O)
          : E >= k && E < P && (l = O + 1)
        : E >= k && (l = O);
    }
  if (
    n.initialized &&
    l !== c &&
    ((!n.allowSlideNext &&
      (g
        ? u > n.translate && u > n.minTranslate()
        : u < n.translate && u < n.minTranslate())) ||
      (!n.allowSlidePrev &&
        u > n.translate &&
        u > n.maxTranslate() &&
        (c || 0) !== l))
  )
    return !1;
  (l !== (p || 0) && t && n.emit("beforeSlideChangeStart"),
    n.updateProgress(u));
  let h;
  l > c ? (h = "next") : l < c ? (h = "prev") : (h = "reset");
  const v = n.virtual && n.params.virtual.enabled;
  if (!(v && r) && ((g && -u === n.translate) || (!g && u === n.translate)))
    return (
      n.updateActiveIndex(l),
      o.autoHeight && n.updateAutoHeight(),
      n.updateSlidesClasses(),
      o.effect !== "slide" && n.setTranslate(u),
      h !== "reset" && (n.transitionStart(t, h), n.transitionEnd(t, h)),
      !1
    );
  if (o.cssMode) {
    const O = n.isHorizontal(),
      E = g ? u : -u;
    if (s === 0)
      (v &&
        ((n.wrapperEl.style.scrollSnapType = "none"),
        (n._immediateVirtual = !0)),
        v && !n._cssModeVirtualInitialSet && n.params.initialSlide > 0
          ? ((n._cssModeVirtualInitialSet = !0),
            requestAnimationFrame(() => {
              d[O ? "scrollLeft" : "scrollTop"] = E;
            }))
          : (d[O ? "scrollLeft" : "scrollTop"] = E),
        v &&
          requestAnimationFrame(() => {
            ((n.wrapperEl.style.scrollSnapType = ""),
              (n._immediateVirtual = !1));
          }));
    else {
      if (!n.support.smoothScroll)
        return (
          xe({ swiper: n, targetPosition: E, side: O ? "left" : "top" }),
          !0
        );
      d.scrollTo({ [O ? "left" : "top"]: E, behavior: "smooth" });
    }
    return !0;
  }
  const A = Le().isSafari;
  return (
    v && !r && A && n.isElement && n.virtual.update(!1, !1, l),
    n.setTransition(s),
    n.setTranslate(u),
    n.updateActiveIndex(l),
    n.updateSlidesClasses(),
    n.emit("beforeTransitionStart", s, i),
    n.transitionStart(t, h),
    s === 0
      ? n.transitionEnd(t, h)
      : n.animating ||
        ((n.animating = !0),
        n.onSlideToWrapperTransitionEnd ||
          (n.onSlideToWrapperTransitionEnd = function (E) {
            !n ||
              n.destroyed ||
              (E.target === this &&
                (n.wrapperEl.removeEventListener(
                  "transitionend",
                  n.onSlideToWrapperTransitionEnd,
                ),
                (n.onSlideToWrapperTransitionEnd = null),
                delete n.onSlideToWrapperTransitionEnd,
                n.transitionEnd(t, h)));
          }),
        n.wrapperEl.addEventListener(
          "transitionend",
          n.onSlideToWrapperTransitionEnd,
        )),
    !0
  );
}
function vt(e = 0, s, t = !0, i) {
  typeof e == "string" && (e = parseInt(e, 10));
  const r = this;
  if (r.destroyed) return;
  typeof s > "u" && (s = r.params.speed);
  const n = r.grid && r.params.grid && r.params.grid.rows > 1;
  let l = e;
  if (r.params.loop)
    if (r.virtual && r.params.virtual.enabled) l = l + r.virtual.slidesBefore;
    else {
      let o;
      if (n) {
        const b = l * r.params.grid.rows;
        o = r.slides.find(
          (y) => y.getAttribute("data-swiper-slide-index") * 1 === b,
        ).column;
      } else o = r.getSlideIndexByData(l);
      const a = n
          ? Math.ceil(r.slides.length / r.params.grid.rows)
          : r.slides.length,
        {
          centeredSlides: f,
          slidesOffsetBefore: p,
          slidesOffsetAfter: c,
        } = r.params,
        g = f || !!p || !!c;
      let d = r.params.slidesPerView;
      d === "auto"
        ? (d = r.slidesPerViewDynamic())
        : ((d = Math.ceil(parseFloat(r.params.slidesPerView, 10))),
          g && d % 2 === 0 && (d = d + 1));
      let m = a - o < d;
      if (
        (g && (m = m || o < Math.ceil(d / 2)),
        i && g && r.params.slidesPerView !== "auto" && !n && (m = !1),
        m)
      ) {
        const b = g
          ? o < r.activeIndex
            ? "prev"
            : "next"
          : o - r.activeIndex - 1 < r.params.slidesPerView
            ? "next"
            : "prev";
        r.loopFix({
          direction: b,
          slideTo: !0,
          activeSlideIndex: b === "next" ? o + 1 : o - a + 1,
          slideRealIndex: b === "next" ? r.realIndex : void 0,
        });
      }
      if (n) {
        const b = l * r.params.grid.rows;
        l = r.slides.find(
          (y) => y.getAttribute("data-swiper-slide-index") * 1 === b,
        ).column;
      } else l = r.getSlideIndexByData(l);
    }
  return (
    requestAnimationFrame(() => {
      r.slideTo(l, s, t, i);
    }),
    r
  );
}
function bt(e, s = !0, t) {
  const i = this,
    { enabled: r, params: n, animating: l } = i;
  if (!r || i.destroyed) return i;
  typeof e > "u" && (e = i.params.speed);
  let o = n.slidesPerGroup;
  n.slidesPerView === "auto" &&
    n.slidesPerGroup === 1 &&
    n.slidesPerGroupAuto &&
    (o = Math.max(i.slidesPerViewDynamic("current", !0), 1));
  const a = i.activeIndex < n.slidesPerGroupSkip ? 1 : o,
    f = i.virtual && n.virtual.enabled;
  if (n.loop) {
    if (l && !f && n.loopPreventsSliding) return !1;
    if (
      (i.loopFix({ direction: "next" }),
      (i._clientLeft = i.wrapperEl.clientLeft),
      i.activeIndex === i.slides.length - 1 && n.cssMode)
    )
      return (
        requestAnimationFrame(() => {
          i.slideTo(i.activeIndex + a, e, s, t);
        }),
        !0
      );
  }
  return n.rewind && i.isEnd
    ? i.slideTo(0, e, s, t)
    : i.slideTo(i.activeIndex + a, e, s, t);
}
function St(e, s = !0, t) {
  const i = this,
    {
      params: r,
      snapGrid: n,
      slidesGrid: l,
      rtlTranslate: o,
      enabled: a,
      animating: f,
    } = i;
  if (!a || i.destroyed) return i;
  typeof e > "u" && (e = i.params.speed);
  const p = i.virtual && r.virtual.enabled;
  if (r.loop) {
    if (f && !p && r.loopPreventsSliding) return !1;
    (i.loopFix({ direction: "prev" }),
      (i._clientLeft = i.wrapperEl.clientLeft));
  }
  const c = o ? i.translate : -i.translate;
  function g(h) {
    return h < 0 ? -Math.floor(Math.abs(h)) : Math.floor(h);
  }
  const d = g(c),
    m = n.map((h) => g(h)),
    b = r.freeMode && r.freeMode.enabled;
  let y = n[m.indexOf(d) - 1];
  if (typeof y > "u" && (r.cssMode || b)) {
    let h;
    (n.forEach((v, x) => {
      d >= v && (h = x);
    }),
      typeof h < "u" && (y = b ? n[h] : n[h > 0 ? h - 1 : h]));
  }
  let u = 0;
  if (
    (typeof y < "u" &&
      ((u = l.indexOf(y)),
      u < 0 && (u = i.activeIndex - 1),
      r.slidesPerView === "auto" &&
        r.slidesPerGroup === 1 &&
        r.slidesPerGroupAuto &&
        ((u = u - i.slidesPerViewDynamic("previous", !0) + 1),
        (u = Math.max(u, 0)))),
    r.rewind && i.isBeginning)
  ) {
    const h =
      i.params.virtual && i.params.virtual.enabled && i.virtual
        ? i.virtual.slides.length - 1
        : i.slides.length - 1;
    return i.slideTo(h, e, s, t);
  } else if (r.loop && i.activeIndex === 0 && r.cssMode)
    return (
      requestAnimationFrame(() => {
        i.slideTo(u, e, s, t);
      }),
      !0
    );
  return i.slideTo(u, e, s, t);
}
function yt(e, s = !0, t) {
  const i = this;
  if (!i.destroyed)
    return (
      typeof e > "u" && (e = i.params.speed),
      i.slideTo(i.activeIndex, e, s, t)
    );
}
function Tt(e, s = !0, t, i = 0.5) {
  const r = this;
  if (r.destroyed) return;
  typeof e > "u" && (e = r.params.speed);
  let n = r.activeIndex;
  const l = Math.min(r.params.slidesPerGroupSkip, n),
    o = l + Math.floor((n - l) / r.params.slidesPerGroup),
    a = r.rtlTranslate ? r.translate : -r.translate;
  if (a >= r.snapGrid[o]) {
    const f = r.snapGrid[o],
      p = r.snapGrid[o + 1];
    a - f > (p - f) * i && (n += r.params.slidesPerGroup);
  } else {
    const f = r.snapGrid[o - 1],
      p = r.snapGrid[o];
    a - f <= (p - f) * i && (n -= r.params.slidesPerGroup);
  }
  return (
    (n = Math.max(n, 0)),
    (n = Math.min(n, r.slidesGrid.length - 1)),
    r.slideTo(n, e, s, t)
  );
}
function xt() {
  const e = this;
  if (e.destroyed) return;
  const { params: s, slidesEl: t } = e,
    i = s.slidesPerView === "auto" ? e.slidesPerViewDynamic() : s.slidesPerView;
  let r = e.getSlideIndexWhenGrid(e.clickedIndex),
    n;
  const l = e.isElement ? "swiper-slide" : `.${s.slideClass}`,
    o = e.grid && e.params.grid && e.params.grid.rows > 1;
  if (s.loop) {
    if (e.animating) return;
    ((n = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10)),
      s.centeredSlides
        ? e.slideToLoop(n)
        : r >
            (o
              ? (e.slides.length - i) / 2 - (e.params.grid.rows - 1)
              : e.slides.length - i)
          ? (e.loopFix(),
            (r = e.getSlideIndex(
              H(t, `${l}[data-swiper-slide-index="${n}"]`)[0],
            )),
            ue(() => {
              e.slideTo(r);
            }))
          : e.slideTo(r));
  } else e.slideTo(r);
}
var Et = {
  slideTo: gt,
  slideToLoop: vt,
  slideNext: bt,
  slidePrev: St,
  slideReset: yt,
  slideToClosest: Tt,
  slideToClickedSlide: xt,
};
function wt(e, s) {
  const t = this,
    { params: i, slidesEl: r } = t;
  if (!i.loop || (t.virtual && t.params.virtual.enabled)) return;
  const n = () => {
      H(r, `.${i.slideClass}, swiper-slide`).forEach((m, b) => {
        m.setAttribute("data-swiper-slide-index", b);
      });
    },
    l = () => {
      const d = H(r, `.${i.slideBlankClass}`);
      (d.forEach((m) => {
        m.remove();
      }),
        d.length > 0 && (t.recalcSlides(), t.updateSlides()));
    },
    o = t.grid && i.grid && i.grid.rows > 1;
  i.loopAddBlankSlides && (i.slidesPerGroup > 1 || o) && l();
  const a = i.slidesPerGroup * (o ? i.grid.rows : 1),
    f = t.slides.length % a !== 0,
    p = o && t.slides.length % i.grid.rows !== 0,
    c = (d) => {
      for (let m = 0; m < d; m += 1) {
        const b = t.isElement
          ? U("swiper-slide", [i.slideBlankClass])
          : U("div", [i.slideClass, i.slideBlankClass]);
        t.slidesEl.append(b);
      }
    };
  if (f) {
    if (i.loopAddBlankSlides) {
      const d = a - (t.slides.length % a);
      (c(d), t.recalcSlides(), t.updateSlides());
    } else
      Z(
        "Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)",
      );
    n();
  } else if (p) {
    if (i.loopAddBlankSlides) {
      const d = i.grid.rows - (t.slides.length % i.grid.rows);
      (c(d), t.recalcSlides(), t.updateSlides());
    } else
      Z(
        "Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)",
      );
    n();
  } else n();
  const g = i.centeredSlides || !!i.slidesOffsetBefore || !!i.slidesOffsetAfter;
  t.loopFix({ slideRealIndex: e, direction: g ? void 0 : "next", initial: s });
}
function Ct({
  slideRealIndex: e,
  slideTo: s = !0,
  direction: t,
  setTranslate: i,
  activeSlideIndex: r,
  initial: n,
  byController: l,
  byMousewheel: o,
} = {}) {
  const a = this;
  if (!a.params.loop) return;
  a.emit("beforeLoopFix");
  const {
      slides: f,
      allowSlidePrev: p,
      allowSlideNext: c,
      slidesEl: g,
      params: d,
    } = a,
    {
      centeredSlides: m,
      slidesOffsetBefore: b,
      slidesOffsetAfter: y,
      initialSlide: u,
    } = d,
    h = m || !!b || !!y;
  if (
    ((a.allowSlidePrev = !0),
    (a.allowSlideNext = !0),
    a.virtual && d.virtual.enabled)
  ) {
    (s &&
      (!h && a.snapIndex === 0
        ? a.slideTo(a.virtual.slides.length, 0, !1, !0)
        : h && a.snapIndex < d.slidesPerView
          ? a.slideTo(a.virtual.slides.length + a.snapIndex, 0, !1, !0)
          : a.snapIndex === a.snapGrid.length - 1 &&
            a.slideTo(a.virtual.slidesBefore, 0, !1, !0)),
      (a.allowSlidePrev = p),
      (a.allowSlideNext = c),
      a.emit("loopFix"));
    return;
  }
  let v = d.slidesPerView;
  v === "auto"
    ? (v = a.slidesPerViewDynamic())
    : ((v = Math.ceil(parseFloat(d.slidesPerView, 10))),
      h && v % 2 === 0 && (v = v + 1));
  const x = d.slidesPerGroupAuto ? v : d.slidesPerGroup;
  let L = h ? Math.max(x, Math.ceil(v / 2)) : x;
  (L % x !== 0 && (L += x - (L % x)),
    (L += d.loopAdditionalSlides),
    (a.loopedSlides = L));
  const A = a.grid && d.grid && d.grid.rows > 1;
  f.length < v + L || (a.params.effect === "cards" && f.length < v + L * 2)
    ? Z(
        "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters",
      )
    : A &&
      d.grid.fill === "row" &&
      Z(
        "Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`",
      );
  const O = [],
    E = [],
    k = A ? Math.ceil(f.length / d.grid.rows) : f.length,
    P = n && k - u < v && !h;
  let S = P ? u : a.activeIndex;
  typeof r > "u"
    ? (r = a.getSlideIndex(
        f.find((M) => M.classList.contains(d.slideActiveClass)),
      ))
    : (S = r);
  const T = t === "next" || !t,
    w = t === "prev" || !t;
  let C = 0,
    I = 0;
  const _ = (A ? f[r].column : r) + (h && typeof i > "u" ? -v / 2 + 0.5 : 0);
  if (_ < L) {
    C = Math.max(L - _, x);
    for (let M = 0; M < L - _; M += 1) {
      const G = M - Math.floor(M / k) * k;
      if (A) {
        const B = k - G - 1;
        for (let q = f.length - 1; q >= 0; q -= 1)
          f[q].column === B && O.push(q);
      } else O.push(k - G - 1);
    }
  } else if (_ + v > k - L) {
    ((I = Math.max(_ - (k - L * 2), x)), P && (I = Math.max(I, v - k + u + 1)));
    for (let M = 0; M < I; M += 1) {
      const G = M - Math.floor(M / k) * k;
      A
        ? f.forEach((B, q) => {
            B.column === G && E.push(q);
          })
        : E.push(G);
    }
  }
  if (
    ((a.__preventObserver__ = !0),
    requestAnimationFrame(() => {
      a.__preventObserver__ = !1;
    }),
    a.params.effect === "cards" &&
      f.length < v + L * 2 &&
      (E.includes(r) && E.splice(E.indexOf(r), 1),
      O.includes(r) && O.splice(O.indexOf(r), 1)),
    w &&
      O.forEach((M) => {
        ((f[M].swiperLoopMoveDOM = !0),
          g.prepend(f[M]),
          (f[M].swiperLoopMoveDOM = !1));
      }),
    T &&
      E.forEach((M) => {
        ((f[M].swiperLoopMoveDOM = !0),
          g.append(f[M]),
          (f[M].swiperLoopMoveDOM = !1));
      }),
    a.recalcSlides(),
    d.slidesPerView === "auto"
      ? a.updateSlides()
      : A &&
        ((O.length > 0 && w) || (E.length > 0 && T)) &&
        a.slides.forEach((M, G) => {
          a.grid.updateSlide(G, M, a.slides);
        }),
    d.watchSlidesProgress && a.updateSlidesOffset(),
    s)
  ) {
    if (O.length > 0 && w) {
      if (typeof e > "u") {
        const M = a.slidesGrid[S],
          B = a.slidesGrid[S + C] - M;
        o
          ? a.setTranslate(a.translate - B)
          : (a.slideTo(S + Math.ceil(C), 0, !1, !0),
            i &&
              ((a.touchEventsData.startTranslate =
                a.touchEventsData.startTranslate - B),
              (a.touchEventsData.currentTranslate =
                a.touchEventsData.currentTranslate - B)));
      } else if (i) {
        const M = A ? O.length / d.grid.rows : O.length;
        (a.slideTo(a.activeIndex + M, 0, !1, !0),
          (a.touchEventsData.currentTranslate = a.translate));
      }
    } else if (E.length > 0 && T)
      if (typeof e > "u") {
        const M = a.slidesGrid[S],
          B = a.slidesGrid[S - I] - M;
        o
          ? a.setTranslate(a.translate - B)
          : (a.slideTo(S - I, 0, !1, !0),
            i &&
              ((a.touchEventsData.startTranslate =
                a.touchEventsData.startTranslate - B),
              (a.touchEventsData.currentTranslate =
                a.touchEventsData.currentTranslate - B)));
      } else {
        const M = A ? E.length / d.grid.rows : E.length;
        a.slideTo(a.activeIndex - M, 0, !1, !0);
      }
  }
  if (
    ((a.allowSlidePrev = p),
    (a.allowSlideNext = c),
    a.controller && a.controller.control && !l)
  ) {
    const M = {
      slideRealIndex: e,
      direction: t,
      setTranslate: i,
      activeSlideIndex: r,
      byController: !0,
    };
    Array.isArray(a.controller.control)
      ? a.controller.control.forEach((G) => {
          !G.destroyed &&
            G.params.loop &&
            G.loopFix({
              ...M,
              slideTo: G.params.slidesPerView === d.slidesPerView ? s : !1,
            });
        })
      : a.controller.control instanceof a.constructor &&
        a.controller.control.params.loop &&
        a.controller.control.loopFix({
          ...M,
          slideTo:
            a.controller.control.params.slidesPerView === d.slidesPerView
              ? s
              : !1,
        });
  }
  a.emit("loopFix");
}
function Pt() {
  const e = this,
    { params: s, slidesEl: t } = e;
  if (!s.loop || !t || (e.virtual && e.params.virtual.enabled)) return;
  e.recalcSlides();
  const i = [];
  (e.slides.forEach((r) => {
    const n =
      typeof r.swiperSlideIndex > "u"
        ? r.getAttribute("data-swiper-slide-index") * 1
        : r.swiperSlideIndex;
    i[n] = r;
  }),
    e.slides.forEach((r) => {
      r.removeAttribute("data-swiper-slide-index");
    }),
    i.forEach((r) => {
      t.append(r);
    }),
    e.recalcSlides(),
    e.slideTo(e.realIndex, 0));
}
var Lt = { loopCreate: wt, loopFix: Ct, loopDestroy: Pt };
function Mt(e) {
  const s = this;
  if (
    !s.params.simulateTouch ||
    (s.params.watchOverflow && s.isLocked) ||
    s.params.cssMode
  )
    return;
  const t = s.params.touchEventsTarget === "container" ? s.el : s.wrapperEl;
  (s.isElement && (s.__preventObserver__ = !0),
    (t.style.cursor = "move"),
    (t.style.cursor = e ? "grabbing" : "grab"),
    s.isElement &&
      requestAnimationFrame(() => {
        s.__preventObserver__ = !1;
      }));
}
function It() {
  const e = this;
  (e.params.watchOverflow && e.isLocked) ||
    e.params.cssMode ||
    (e.isElement && (e.__preventObserver__ = !0),
    (e[
      e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"
    ].style.cursor = ""),
    e.isElement &&
      requestAnimationFrame(() => {
        e.__preventObserver__ = !1;
      }));
}
var At = { setGrabCursor: Mt, unsetGrabCursor: It };
function Ot(e, s = this) {
  function t(i) {
    if (!i || i === N() || i === V()) return null;
    i.assignedSlot && (i = i.assignedSlot);
    const r = i.closest(e);
    return !r && !i.getRootNode ? null : r || t(i.getRootNode().host);
  }
  return t(s);
}
function ge(e, s, t) {
  const i = V(),
    { params: r } = e,
    n = r.edgeSwipeDetection,
    l = r.edgeSwipeThreshold;
  return n && (t <= l || t >= i.innerWidth - l)
    ? n === "prevent"
      ? (s.preventDefault(), !0)
      : !1
    : !0;
}
function kt(e) {
  const s = this,
    t = N();
  let i = e;
  i.originalEvent && (i = i.originalEvent);
  const r = s.touchEventsData;
  if (i.type === "pointerdown") {
    if (r.pointerId !== null && r.pointerId !== i.pointerId) return;
    r.pointerId = i.pointerId;
  } else
    i.type === "touchstart" &&
      i.targetTouches.length === 1 &&
      (r.touchId = i.targetTouches[0].identifier);
  if (i.type === "touchstart") {
    ge(s, i, i.targetTouches[0].pageX);
    return;
  }
  const { params: n, touches: l, enabled: o } = s;
  if (
    !o ||
    (!n.simulateTouch && i.pointerType === "mouse") ||
    (s.animating && n.preventInteractionOnTransition)
  )
    return;
  !s.animating && n.cssMode && n.loop && s.loopFix();
  let a = i.target;
  if (
    (n.touchEventsTarget === "wrapper" && !Be(a, s.wrapperEl)) ||
    ("which" in i && i.which === 3) ||
    ("button" in i && i.button > 0) ||
    (r.isTouched && r.isMoved)
  )
    return;
  const f = !!n.noSwipingClass && n.noSwipingClass !== "",
    p = i.composedPath ? i.composedPath() : i.path;
  f && i.target && i.target.shadowRoot && p && (a = p[0]);
  const c = n.noSwipingSelector ? n.noSwipingSelector : `.${n.noSwipingClass}`,
    g = !!(i.target && i.target.shadowRoot);
  if (n.noSwiping && (g ? Ot(c, a) : a.closest(c))) {
    s.allowClick = !0;
    return;
  }
  if (n.swipeHandler && !a.closest(n.swipeHandler)) return;
  ((l.currentX = i.pageX), (l.currentY = i.pageY));
  const d = l.currentX,
    m = l.currentY;
  if (!ge(s, i, d)) return;
  (Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0,
  }),
    (l.startX = d),
    (l.startY = m),
    (r.touchStartTime = Q()),
    (s.allowClick = !0),
    s.updateSize(),
    (s.swipeDirection = void 0),
    n.threshold > 0 && (r.allowThresholdMove = !1));
  let b = !0;
  (a.matches(r.focusableElements) &&
    ((b = !1), a.nodeName === "SELECT" && (r.isTouched = !1)),
    t.activeElement &&
      t.activeElement.matches(r.focusableElements) &&
      t.activeElement !== a &&
      (i.pointerType === "mouse" ||
        (i.pointerType !== "mouse" && !a.matches(r.focusableElements))) &&
      t.activeElement.blur());
  const y = b && s.allowTouchMove && n.touchStartPreventDefault;
  ((n.touchStartForcePreventDefault || y) &&
    !a.isContentEditable &&
    i.preventDefault(),
    n.freeMode &&
      n.freeMode.enabled &&
      s.freeMode &&
      s.animating &&
      !n.cssMode &&
      s.freeMode.onTouchStart(),
    s.emit("touchStart", i));
}
function zt(e) {
  const s = N(),
    t = this,
    i = t.touchEventsData,
    { params: r, touches: n, rtlTranslate: l, enabled: o } = t;
  if (!o || (!r.simulateTouch && e.pointerType === "mouse")) return;
  let a = e;
  if (
    (a.originalEvent && (a = a.originalEvent),
    a.type === "pointermove" &&
      (i.touchId !== null || a.pointerId !== i.pointerId))
  )
    return;
  let f;
  if (a.type === "touchmove") {
    if (
      ((f = [...a.changedTouches].find((A) => A.identifier === i.touchId)),
      !f || f.identifier !== i.touchId)
    )
      return;
  } else f = a;
  if (!i.isTouched) {
    i.startMoving && i.isScrolling && t.emit("touchMoveOpposite", a);
    return;
  }
  const p = f.pageX,
    c = f.pageY;
  if (a.preventedByNestedSwiper) {
    ((n.startX = p), (n.startY = c));
    return;
  }
  if (!t.allowTouchMove) {
    (a.target.matches(i.focusableElements) || (t.allowClick = !1),
      i.isTouched &&
        (Object.assign(n, { startX: p, startY: c, currentX: p, currentY: c }),
        (i.touchStartTime = Q())));
    return;
  }
  if (r.touchReleaseOnEdges && !r.loop)
    if (t.isVertical()) {
      if (
        (c < n.startY && t.translate <= t.maxTranslate()) ||
        (c > n.startY && t.translate >= t.minTranslate())
      ) {
        ((i.isTouched = !1), (i.isMoved = !1));
        return;
      }
    } else {
      if (
        l &&
        ((p > n.startX && -t.translate <= t.maxTranslate()) ||
          (p < n.startX && -t.translate >= t.minTranslate()))
      )
        return;
      if (
        !l &&
        ((p < n.startX && t.translate <= t.maxTranslate()) ||
          (p > n.startX && t.translate >= t.minTranslate()))
      )
        return;
    }
  if (
    (s.activeElement &&
      s.activeElement.matches(i.focusableElements) &&
      s.activeElement !== a.target &&
      a.pointerType !== "mouse" &&
      s.activeElement.blur(),
    s.activeElement &&
      a.target === s.activeElement &&
      a.target.matches(i.focusableElements))
  ) {
    ((i.isMoved = !0), (t.allowClick = !1));
    return;
  }
  (i.allowTouchCallbacks && t.emit("touchMove", a),
    (n.previousX = n.currentX),
    (n.previousY = n.currentY),
    (n.currentX = p),
    (n.currentY = c));
  const g = n.currentX - n.startX,
    d = n.currentY - n.startY;
  if (t.params.threshold && Math.sqrt(g ** 2 + d ** 2) < t.params.threshold)
    return;
  if (typeof i.isScrolling > "u") {
    let A;
    (t.isHorizontal() && n.currentY === n.startY) ||
    (t.isVertical() && n.currentX === n.startX)
      ? (i.isScrolling = !1)
      : g * g + d * d >= 25 &&
        ((A = (Math.atan2(Math.abs(d), Math.abs(g)) * 180) / Math.PI),
        (i.isScrolling = t.isHorizontal()
          ? A > r.touchAngle
          : 90 - A > r.touchAngle));
  }
  if (
    (i.isScrolling && t.emit("touchMoveOpposite", a),
    typeof i.startMoving > "u" &&
      (n.currentX !== n.startX || n.currentY !== n.startY) &&
      (i.startMoving = !0),
    i.isScrolling ||
      (a.type === "touchmove" && i.preventTouchMoveFromPointerMove))
  ) {
    i.isTouched = !1;
    return;
  }
  if (!i.startMoving) return;
  ((t.allowClick = !1),
    !r.cssMode && a.cancelable && a.preventDefault(),
    r.touchMoveStopPropagation && !r.nested && a.stopPropagation());
  let m = t.isHorizontal() ? g : d,
    b = t.isHorizontal() ? n.currentX - n.previousX : n.currentY - n.previousY;
  (r.oneWayMovement &&
    ((m = Math.abs(m) * (l ? 1 : -1)), (b = Math.abs(b) * (l ? 1 : -1))),
    (n.diff = m),
    (m *= r.touchRatio),
    l && ((m = -m), (b = -b)));
  const y = t.touchesDirection;
  ((t.swipeDirection = m > 0 ? "prev" : "next"),
    (t.touchesDirection = b > 0 ? "prev" : "next"));
  const u = t.params.loop && !r.cssMode,
    h =
      (t.touchesDirection === "next" && t.allowSlideNext) ||
      (t.touchesDirection === "prev" && t.allowSlidePrev);
  if (!i.isMoved) {
    if (
      (u && h && t.loopFix({ direction: t.swipeDirection }),
      (i.startTranslate = t.getTranslate()),
      t.setTransition(0),
      t.animating)
    ) {
      const A = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: { bySwiperTouchMove: !0 },
      });
      t.wrapperEl.dispatchEvent(A);
    }
    ((i.allowMomentumBounce = !1),
      r.grabCursor &&
        (t.allowSlideNext === !0 || t.allowSlidePrev === !0) &&
        t.setGrabCursor(!0),
      t.emit("sliderFirstMove", a));
  }
  let v;
  if (
    (new Date().getTime(),
    r._loopSwapReset !== !1 &&
      i.isMoved &&
      i.allowThresholdMove &&
      y !== t.touchesDirection &&
      u &&
      h &&
      Math.abs(m) >= 1)
  ) {
    (Object.assign(n, {
      startX: p,
      startY: c,
      currentX: p,
      currentY: c,
      startTranslate: i.currentTranslate,
    }),
      (i.loopSwapReset = !0),
      (i.startTranslate = i.currentTranslate));
    return;
  }
  (t.emit("sliderMove", a),
    (i.isMoved = !0),
    (i.currentTranslate = m + i.startTranslate));
  let x = !0,
    L = r.resistanceRatio;
  if (
    (r.touchReleaseOnEdges && (L = 0),
    m > 0
      ? (u &&
          h &&
          !v &&
          i.allowThresholdMove &&
          i.currentTranslate >
            (r.centeredSlides
              ? t.minTranslate() -
                t.slidesSizesGrid[t.activeIndex + 1] -
                (r.slidesPerView !== "auto" &&
                t.slides.length - r.slidesPerView >= 2
                  ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween
                  : 0) -
                t.params.spaceBetween
              : t.minTranslate()) &&
          t.loopFix({
            direction: "prev",
            setTranslate: !0,
            activeSlideIndex: 0,
          }),
        i.currentTranslate > t.minTranslate() &&
          ((x = !1),
          r.resistance &&
            (i.currentTranslate =
              t.minTranslate() -
              1 +
              (-t.minTranslate() + i.startTranslate + m) ** L)))
      : m < 0 &&
        (u &&
          h &&
          !v &&
          i.allowThresholdMove &&
          i.currentTranslate <
            (r.centeredSlides
              ? t.maxTranslate() +
                t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                t.params.spaceBetween +
                (r.slidesPerView !== "auto" &&
                t.slides.length - r.slidesPerView >= 2
                  ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] +
                    t.params.spaceBetween
                  : 0)
              : t.maxTranslate()) &&
          t.loopFix({
            direction: "next",
            setTranslate: !0,
            activeSlideIndex:
              t.slides.length -
              (r.slidesPerView === "auto"
                ? t.slidesPerViewDynamic()
                : Math.ceil(parseFloat(r.slidesPerView, 10))),
          }),
        i.currentTranslate < t.maxTranslate() &&
          ((x = !1),
          r.resistance &&
            (i.currentTranslate =
              t.maxTranslate() +
              1 -
              (t.maxTranslate() - i.startTranslate - m) ** L))),
    x && (a.preventedByNestedSwiper = !0),
    !t.allowSlideNext &&
      t.swipeDirection === "next" &&
      i.currentTranslate < i.startTranslate &&
      (i.currentTranslate = i.startTranslate),
    !t.allowSlidePrev &&
      t.swipeDirection === "prev" &&
      i.currentTranslate > i.startTranslate &&
      (i.currentTranslate = i.startTranslate),
    !t.allowSlidePrev &&
      !t.allowSlideNext &&
      (i.currentTranslate = i.startTranslate),
    r.threshold > 0)
  )
    if (Math.abs(m) > r.threshold || i.allowThresholdMove) {
      if (!i.allowThresholdMove) {
        ((i.allowThresholdMove = !0),
          (n.startX = n.currentX),
          (n.startY = n.currentY),
          (i.currentTranslate = i.startTranslate),
          (n.diff = t.isHorizontal()
            ? n.currentX - n.startX
            : n.currentY - n.startY));
        return;
      }
    } else {
      i.currentTranslate = i.startTranslate;
      return;
    }
  !r.followFinger ||
    r.cssMode ||
    (((r.freeMode && r.freeMode.enabled && t.freeMode) ||
      r.watchSlidesProgress) &&
      (t.updateActiveIndex(), t.updateSlidesClasses()),
    r.freeMode && r.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(),
    t.updateProgress(i.currentTranslate),
    t.setTranslate(i.currentTranslate));
}
function Dt(e) {
  const s = this,
    t = s.touchEventsData;
  let i = e;
  i.originalEvent && (i = i.originalEvent);
  let r;
  if (i.type === "touchend" || i.type === "touchcancel") {
    if (
      ((r = [...i.changedTouches].find((L) => L.identifier === t.touchId)),
      !r || r.identifier !== t.touchId)
    )
      return;
  } else {
    if (t.touchId !== null || i.pointerId !== t.pointerId) return;
    r = i;
  }
  if (
    ["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(
      i.type,
    ) &&
    !(
      ["pointercancel", "contextmenu"].includes(i.type) &&
      (s.browser.isSafari || s.browser.isWebView)
    )
  )
    return;
  ((t.pointerId = null), (t.touchId = null));
  const {
    params: l,
    touches: o,
    rtlTranslate: a,
    slidesGrid: f,
    enabled: p,
  } = s;
  if (!p || (!l.simulateTouch && i.pointerType === "mouse")) return;
  if (
    (t.allowTouchCallbacks && s.emit("touchEnd", i),
    (t.allowTouchCallbacks = !1),
    !t.isTouched)
  ) {
    (t.isMoved && l.grabCursor && s.setGrabCursor(!1),
      (t.isMoved = !1),
      (t.startMoving = !1));
    return;
  }
  l.grabCursor &&
    t.isMoved &&
    t.isTouched &&
    (s.allowSlideNext === !0 || s.allowSlidePrev === !0) &&
    s.setGrabCursor(!1);
  const c = Q(),
    g = c - t.touchStartTime;
  if (s.allowClick) {
    const L = i.path || (i.composedPath && i.composedPath());
    (s.updateClickedSlide((L && L[0]) || i.target, L),
      s.emit("tap click", i),
      g < 300 &&
        c - t.lastClickTime < 300 &&
        s.emit("doubleTap doubleClick", i));
  }
  if (
    ((t.lastClickTime = Q()),
    ue(() => {
      s.destroyed || (s.allowClick = !0);
    }),
    !t.isTouched ||
      !t.isMoved ||
      !s.swipeDirection ||
      (o.diff === 0 && !t.loopSwapReset) ||
      (t.currentTranslate === t.startTranslate && !t.loopSwapReset))
  ) {
    ((t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1));
    return;
  }
  ((t.isTouched = !1), (t.isMoved = !1), (t.startMoving = !1));
  let d;
  if (
    (l.followFinger
      ? (d = a ? s.translate : -s.translate)
      : (d = -t.currentTranslate),
    l.cssMode)
  )
    return;
  if (l.freeMode && l.freeMode.enabled) {
    s.freeMode.onTouchEnd({ currentPos: d });
    return;
  }
  const m = d >= -s.maxTranslate() && !s.params.loop;
  let b = 0,
    y = s.slidesSizesGrid[0];
  for (
    let L = 0;
    L < f.length;
    L += L < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup
  ) {
    const A = L < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
    typeof f[L + A] < "u"
      ? (m || (d >= f[L] && d < f[L + A])) && ((b = L), (y = f[L + A] - f[L]))
      : (m || d >= f[L]) && ((b = L), (y = f[f.length - 1] - f[f.length - 2]));
  }
  let u = null,
    h = null;
  l.rewind &&
    (s.isBeginning
      ? (h =
          l.virtual && l.virtual.enabled && s.virtual
            ? s.virtual.slides.length - 1
            : s.slides.length - 1)
      : s.isEnd && (u = 0));
  const v = (d - f[b]) / y,
    x = b < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
  if (g > l.longSwipesMs) {
    if (!l.longSwipes) {
      s.slideTo(s.activeIndex);
      return;
    }
    (s.swipeDirection === "next" &&
      (v >= l.longSwipesRatio
        ? s.slideTo(l.rewind && s.isEnd ? u : b + x)
        : s.slideTo(b)),
      s.swipeDirection === "prev" &&
        (v > 1 - l.longSwipesRatio
          ? s.slideTo(b + x)
          : h !== null && v < 0 && Math.abs(v) > l.longSwipesRatio
            ? s.slideTo(h)
            : s.slideTo(b)));
  } else {
    if (!l.shortSwipes) {
      s.slideTo(s.activeIndex);
      return;
    }
    s.navigation &&
    (i.target === s.navigation.nextEl || i.target === s.navigation.prevEl)
      ? i.target === s.navigation.nextEl
        ? s.slideTo(b + x)
        : s.slideTo(b)
      : (s.swipeDirection === "next" && s.slideTo(u !== null ? u : b + x),
        s.swipeDirection === "prev" && s.slideTo(h !== null ? h : b));
  }
}
function ve() {
  const e = this,
    { params: s, el: t } = e;
  if (t && t.offsetWidth === 0) return;
  s.breakpoints && e.setBreakpoint();
  const { allowSlideNext: i, allowSlidePrev: r, snapGrid: n } = e,
    l = e.virtual && e.params.virtual.enabled;
  ((e.allowSlideNext = !0),
    (e.allowSlidePrev = !0),
    e.updateSize(),
    e.updateSlides(),
    e.updateSlidesClasses());
  const o = l && s.loop;
  if (
    (s.slidesPerView === "auto" || s.slidesPerView > 1) &&
    e.isEnd &&
    !e.isBeginning &&
    !e.params.centeredSlides &&
    !o
  ) {
    const a = l ? e.virtual.slides : e.slides;
    e.slideTo(a.length - 1, 0, !1, !0);
  } else
    e.params.loop && !l
      ? e.slideToLoop(e.realIndex, 0, !1, !0)
      : e.slideTo(e.activeIndex, 0, !1, !0);
  (e.autoplay &&
    e.autoplay.running &&
    e.autoplay.paused &&
    (clearTimeout(e.autoplay.resizeTimeout),
    (e.autoplay.resizeTimeout = setTimeout(() => {
      e.autoplay &&
        e.autoplay.running &&
        e.autoplay.paused &&
        e.autoplay.resume();
    }, 500))),
    (e.allowSlidePrev = r),
    (e.allowSlideNext = i),
    e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow());
}
function Gt(e) {
  const s = this;
  s.enabled &&
    (s.allowClick ||
      (s.params.preventClicks && e.preventDefault(),
      s.params.preventClicksPropagation &&
        s.animating &&
        (e.stopPropagation(), e.stopImmediatePropagation())));
}
function _t() {
  const e = this,
    { wrapperEl: s, rtlTranslate: t, enabled: i } = e;
  if (!i) return;
  ((e.previousTranslate = e.translate),
    e.isHorizontal()
      ? (e.translate = -s.scrollLeft)
      : (e.translate = -s.scrollTop),
    e.translate === 0 && (e.translate = 0),
    e.updateActiveIndex(),
    e.updateSlidesClasses());
  let r;
  const n = e.maxTranslate() - e.minTranslate();
  (n === 0 ? (r = 0) : (r = (e.translate - e.minTranslate()) / n),
    r !== e.progress && e.updateProgress(t ? -e.translate : e.translate),
    e.emit("setTranslate", e.translate, !1));
}
function Vt(e) {
  const s = this;
  (K(s, e.target),
    !(
      s.params.cssMode ||
      (s.params.slidesPerView !== "auto" && !s.params.autoHeight)
    ) && s.update());
}
function Bt() {
  const e = this;
  e.documentTouchHandlerProceeded ||
    ((e.documentTouchHandlerProceeded = !0),
    e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
const Ie = (e, s) => {
  const t = N(),
    { params: i, el: r, wrapperEl: n, device: l } = e,
    o = !!i.nested,
    a = s === "on" ? "addEventListener" : "removeEventListener",
    f = s;
  !r ||
    typeof r == "string" ||
    (t[a]("touchstart", e.onDocumentTouchStart, { passive: !1, capture: o }),
    r[a]("touchstart", e.onTouchStart, { passive: !1 }),
    r[a]("pointerdown", e.onTouchStart, { passive: !1 }),
    t[a]("touchmove", e.onTouchMove, { passive: !1, capture: o }),
    t[a]("pointermove", e.onTouchMove, { passive: !1, capture: o }),
    t[a]("touchend", e.onTouchEnd, { passive: !0 }),
    t[a]("pointerup", e.onTouchEnd, { passive: !0 }),
    t[a]("pointercancel", e.onTouchEnd, { passive: !0 }),
    t[a]("touchcancel", e.onTouchEnd, { passive: !0 }),
    t[a]("pointerout", e.onTouchEnd, { passive: !0 }),
    t[a]("pointerleave", e.onTouchEnd, { passive: !0 }),
    t[a]("contextmenu", e.onTouchEnd, { passive: !0 }),
    (i.preventClicks || i.preventClicksPropagation) &&
      r[a]("click", e.onClick, !0),
    i.cssMode && n[a]("scroll", e.onScroll),
    i.updateOnWindowResize
      ? e[f](
          l.ios || l.android
            ? "resize orientationchange observerUpdate"
            : "resize observerUpdate",
          ve,
          !0,
        )
      : e[f]("observerUpdate", ve, !0),
    r[a]("load", e.onLoad, { capture: !0 }));
};
function $t() {
  const e = this,
    { params: s } = e;
  ((e.onTouchStart = kt.bind(e)),
    (e.onTouchMove = zt.bind(e)),
    (e.onTouchEnd = Dt.bind(e)),
    (e.onDocumentTouchStart = Bt.bind(e)),
    s.cssMode && (e.onScroll = _t.bind(e)),
    (e.onClick = Gt.bind(e)),
    (e.onLoad = Vt.bind(e)),
    Ie(e, "on"));
}
function Ft() {
  Ie(this, "off");
}
var Ht = { attachEvents: $t, detachEvents: Ft };
const be = (e, s) => e.grid && s.grid && s.grid.rows > 1;
function Nt() {
  const e = this,
    { realIndex: s, initialized: t, params: i, el: r } = e,
    n = i.breakpoints;
  if (!n || (n && Object.keys(n).length === 0)) return;
  const l = N(),
    o =
      i.breakpointsBase === "window" || !i.breakpointsBase
        ? i.breakpointsBase
        : "container",
    a =
      ["window", "container"].includes(i.breakpointsBase) || !i.breakpointsBase
        ? e.el
        : l.querySelector(i.breakpointsBase),
    f = e.getBreakpoint(n, o, a);
  if (!f || e.currentBreakpoint === f) return;
  const c = (f in n ? n[f] : void 0) || e.originalParams,
    g = be(e, i),
    d = be(e, c),
    m = e.params.grabCursor,
    b = c.grabCursor,
    y = i.enabled;
  (g && !d
    ? (r.classList.remove(
        `${i.containerModifierClass}grid`,
        `${i.containerModifierClass}grid-column`,
      ),
      e.emitContainerClasses())
    : !g &&
      d &&
      (r.classList.add(`${i.containerModifierClass}grid`),
      ((c.grid.fill && c.grid.fill === "column") ||
        (!c.grid.fill && i.grid.fill === "column")) &&
        r.classList.add(`${i.containerModifierClass}grid-column`),
      e.emitContainerClasses()),
    m && !b ? e.unsetGrabCursor() : !m && b && e.setGrabCursor(),
    ["navigation", "pagination", "scrollbar"].forEach((A) => {
      if (typeof c[A] > "u") return;
      const O = i[A] && i[A].enabled,
        E = c[A] && c[A].enabled;
      (O && !E && e[A].disable(), !O && E && e[A].enable());
    }));
  const u = c.direction && c.direction !== i.direction,
    h = i.loop && (c.slidesPerView !== i.slidesPerView || u),
    v = i.loop;
  (u && t && e.changeDirection(), F(e.params, c));
  const x = e.params.enabled,
    L = e.params.loop;
  (Object.assign(e, {
    allowTouchMove: e.params.allowTouchMove,
    allowSlideNext: e.params.allowSlideNext,
    allowSlidePrev: e.params.allowSlidePrev,
  }),
    y && !x ? e.disable() : !y && x && e.enable(),
    (e.currentBreakpoint = f),
    e.emit("_beforeBreakpoint", c),
    t &&
      (h
        ? (e.loopDestroy(), e.loopCreate(s), e.updateSlides())
        : !v && L
          ? (e.loopCreate(s), e.updateSlides())
          : v && !L && e.loopDestroy()),
    e.emit("breakpoint", c));
}
function qt(e, s = "window", t) {
  if (!e || (s === "container" && !t)) return;
  let i = !1;
  const r = V(),
    n = s === "window" ? r.innerHeight : t.clientHeight,
    l = Object.keys(e).map((o) => {
      if (typeof o == "string" && o.indexOf("@") === 0) {
        const a = parseFloat(o.substr(1));
        return { value: n * a, point: o };
      }
      return { value: o, point: o };
    });
  l.sort((o, a) => parseInt(o.value, 10) - parseInt(a.value, 10));
  for (let o = 0; o < l.length; o += 1) {
    const { point: a, value: f } = l[o];
    s === "window"
      ? r.matchMedia(`(min-width: ${f}px)`).matches && (i = a)
      : f <= t.clientWidth && (i = a);
  }
  return i || "max";
}
var Rt = { setBreakpoint: Nt, getBreakpoint: qt };
function jt(e, s) {
  const t = [];
  return (
    e.forEach((i) => {
      typeof i == "object"
        ? Object.keys(i).forEach((r) => {
            i[r] && t.push(s + r);
          })
        : typeof i == "string" && t.push(s + i);
    }),
    t
  );
}
function Wt() {
  const e = this,
    { classNames: s, params: t, rtl: i, el: r, device: n } = e,
    l = jt(
      [
        "initialized",
        t.direction,
        { "free-mode": e.params.freeMode && t.freeMode.enabled },
        { autoheight: t.autoHeight },
        { rtl: i },
        { grid: t.grid && t.grid.rows > 1 },
        {
          "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column",
        },
        { android: n.android },
        { ios: n.ios },
        { "css-mode": t.cssMode },
        { centered: t.cssMode && t.centeredSlides },
        { "watch-progress": t.watchSlidesProgress },
      ],
      t.containerModifierClass,
    );
  (s.push(...l), r.classList.add(...s), e.emitContainerClasses());
}
function Yt() {
  const e = this,
    { el: s, classNames: t } = e;
  !s ||
    typeof s == "string" ||
    (s.classList.remove(...t), e.emitContainerClasses());
}
var Xt = { addClasses: Wt, removeClasses: Yt };
function Ut() {
  const e = this,
    { isLocked: s, params: t } = e,
    { slidesOffsetBefore: i } = t;
  if (i) {
    const r = e.slides.length - 1,
      n = e.slidesGrid[r] + e.slidesSizesGrid[r] + i * 2;
    e.isLocked = e.size > n;
  } else e.isLocked = e.snapGrid.length === 1;
  (t.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked),
    t.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked),
    s && s !== e.isLocked && (e.isEnd = !1),
    s !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"));
}
var Kt = { checkOverflow: Ut },
  Se = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    snapToSlideEdge: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
function Qt(e, s) {
  return function (i = {}) {
    const r = Object.keys(i)[0],
      n = i[r];
    if (typeof n != "object" || n === null) {
      F(s, i);
      return;
    }
    if (
      (e[r] === !0 && (e[r] = { enabled: !0 }),
      r === "navigation" &&
        e[r] &&
        e[r].enabled &&
        !e[r].prevEl &&
        !e[r].nextEl &&
        (e[r].auto = !0),
      ["pagination", "scrollbar"].indexOf(r) >= 0 &&
        e[r] &&
        e[r].enabled &&
        !e[r].el &&
        (e[r].auto = !0),
      !(r in e && "enabled" in n))
    ) {
      F(s, i);
      return;
    }
    (typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = !0),
      e[r] || (e[r] = { enabled: !1 }),
      F(s, i));
  };
}
const re = {
    eventsEmitter: Xe,
    update: rt,
    translate: ft,
    transition: ht,
    slide: Et,
    loop: Lt,
    grabCursor: At,
    events: Ht,
    breakpoints: Rt,
    checkOverflow: Kt,
    classes: Xt,
  },
  ae = {};
class $ {
  constructor(...s) {
    let t, i;
    (s.length === 1 &&
    s[0].constructor &&
    Object.prototype.toString.call(s[0]).slice(8, -1) === "Object"
      ? (i = s[0])
      : ([t, i] = s),
      i || (i = {}),
      (i = F({}, i)),
      t && !i.el && (i.el = t));
    const r = N();
    if (
      i.el &&
      typeof i.el == "string" &&
      r.querySelectorAll(i.el).length > 1
    ) {
      const a = [];
      return (
        r.querySelectorAll(i.el).forEach((f) => {
          const p = F({}, i, { el: f });
          a.push(new $(p));
        }),
        a
      );
    }
    const n = this;
    ((n.__swiper__ = !0),
      (n.support = Ce()),
      (n.device = Pe({ userAgent: i.userAgent })),
      (n.browser = Le()),
      (n.eventsListeners = {}),
      (n.eventsAnyListeners = []),
      (n.modules = [...n.__modules__]),
      i.modules &&
        Array.isArray(i.modules) &&
        i.modules.forEach((a) => {
          typeof a == "function" &&
            n.modules.indexOf(a) < 0 &&
            n.modules.push(a);
        }));
    const l = {};
    n.modules.forEach((a) => {
      a({
        params: i,
        swiper: n,
        extendParams: Qt(i, l),
        on: n.on.bind(n),
        once: n.once.bind(n),
        off: n.off.bind(n),
        emit: n.emit.bind(n),
      });
    });
    const o = F({}, Se, l);
    return (
      (n.params = F({}, o, ae, i)),
      (n.originalParams = F({}, n.params)),
      (n.passedParams = F({}, i)),
      n.params &&
        n.params.on &&
        Object.keys(n.params.on).forEach((a) => {
          n.on(a, n.params.on[a]);
        }),
      n.params && n.params.onAny && n.onAny(n.params.onAny),
      Object.assign(n, {
        enabled: n.params.enabled,
        el: t,
        classNames: [],
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        isHorizontal() {
          return n.params.direction === "horizontal";
        },
        isVertical() {
          return n.params.direction === "vertical";
        },
        activeIndex: 0,
        realIndex: 0,
        isBeginning: !0,
        isEnd: !1,
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: !1,
        cssOverflowAdjustment() {
          return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
        },
        allowSlideNext: n.params.allowSlideNext,
        allowSlidePrev: n.params.allowSlidePrev,
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          focusableElements: n.params.focusableElements,
          lastClickTime: 0,
          clickTimeout: void 0,
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null,
        },
        allowClick: !0,
        allowTouchMove: n.params.allowTouchMove,
        touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
        imagesToLoad: [],
        imagesLoaded: 0,
      }),
      n.emit("_swiper"),
      n.params.init && n.init(),
      n
    );
  }
  getDirectionLabel(s) {
    return this.isHorizontal()
      ? s
      : {
          width: "height",
          "margin-top": "margin-left",
          "margin-bottom ": "margin-right",
          "margin-left": "margin-top",
          "margin-right": "margin-bottom",
          "padding-left": "padding-top",
          "padding-right": "padding-bottom",
          marginRight: "marginBottom",
        }[s];
  }
  getSlideIndex(s) {
    const { slidesEl: t, params: i } = this,
      r = H(t, `.${i.slideClass}, swiper-slide`),
      n = J(r[0]);
    return J(s) - n;
  }
  getSlideIndexByData(s) {
    return this.getSlideIndex(
      this.slides.find(
        (t) => t.getAttribute("data-swiper-slide-index") * 1 === s,
      ),
    );
  }
  getSlideIndexWhenGrid(s) {
    return (
      this.grid &&
        this.params.grid &&
        this.params.grid.rows > 1 &&
        (this.params.grid.fill === "column"
          ? (s = Math.floor(s / this.params.grid.rows))
          : this.params.grid.fill === "row" &&
            (s = s % Math.ceil(this.slides.length / this.params.grid.rows))),
      s
    );
  }
  recalcSlides() {
    const s = this,
      { slidesEl: t, params: i } = s;
    s.slides = H(t, `.${i.slideClass}, swiper-slide`);
  }
  enable() {
    const s = this;
    s.enabled ||
      ((s.enabled = !0),
      s.params.grabCursor && s.setGrabCursor(),
      s.emit("enable"));
  }
  disable() {
    const s = this;
    s.enabled &&
      ((s.enabled = !1),
      s.params.grabCursor && s.unsetGrabCursor(),
      s.emit("disable"));
  }
  setProgress(s, t) {
    const i = this;
    s = Math.min(Math.max(s, 0), 1);
    const r = i.minTranslate(),
      l = (i.maxTranslate() - r) * s + r;
    (i.translateTo(l, typeof t > "u" ? 0 : t),
      i.updateActiveIndex(),
      i.updateSlidesClasses());
  }
  emitContainerClasses() {
    const s = this;
    if (!s.params._emitClasses || !s.el) return;
    const t = s.el.className
      .split(" ")
      .filter(
        (i) =>
          i.indexOf("swiper") === 0 ||
          i.indexOf(s.params.containerModifierClass) === 0,
      );
    s.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(s) {
    const t = this;
    return t.destroyed
      ? ""
      : s.className
          .split(" ")
          .filter(
            (i) =>
              i.indexOf("swiper-slide") === 0 ||
              i.indexOf(t.params.slideClass) === 0,
          )
          .join(" ");
  }
  emitSlidesClasses() {
    const s = this;
    if (!s.params._emitClasses || !s.el) return;
    const t = [];
    (s.slides.forEach((i) => {
      const r = s.getSlideClasses(i);
      (t.push({ slideEl: i, classNames: r }), s.emit("_slideClass", i, r));
    }),
      s.emit("_slideClasses", t));
  }
  slidesPerViewDynamic(s = "current", t = !1) {
    const i = this,
      {
        params: r,
        slides: n,
        slidesGrid: l,
        slidesSizesGrid: o,
        size: a,
        activeIndex: f,
      } = i;
    let p = 1;
    if (typeof r.slidesPerView == "number") return r.slidesPerView;
    if (r.centeredSlides) {
      let c = n[f] ? Math.ceil(n[f].swiperSlideSize) : 0,
        g;
      for (let d = f + 1; d < n.length; d += 1)
        n[d] &&
          !g &&
          ((c += Math.ceil(n[d].swiperSlideSize)), (p += 1), c > a && (g = !0));
      for (let d = f - 1; d >= 0; d -= 1)
        n[d] &&
          !g &&
          ((c += n[d].swiperSlideSize), (p += 1), c > a && (g = !0));
    } else if (s === "current")
      for (let c = f + 1; c < n.length; c += 1)
        (t ? l[c] + o[c] - l[f] < a : l[c] - l[f] < a) && (p += 1);
    else for (let c = f - 1; c >= 0; c -= 1) l[f] - l[c] < a && (p += 1);
    return p;
  }
  update() {
    const s = this;
    if (!s || s.destroyed) return;
    const { snapGrid: t, params: i } = s;
    (i.breakpoints && s.setBreakpoint(),
      [...s.el.querySelectorAll('[loading="lazy"]')].forEach((l) => {
        l.complete && K(s, l);
      }),
      s.updateSize(),
      s.updateSlides(),
      s.updateProgress(),
      s.updateSlidesClasses());
    function r() {
      const l = s.rtlTranslate ? s.translate * -1 : s.translate,
        o = Math.min(Math.max(l, s.maxTranslate()), s.minTranslate());
      (s.setTranslate(o), s.updateActiveIndex(), s.updateSlidesClasses());
    }
    let n;
    if (i.freeMode && i.freeMode.enabled && !i.cssMode)
      (r(), i.autoHeight && s.updateAutoHeight());
    else {
      if (
        (i.slidesPerView === "auto" || i.slidesPerView > 1) &&
        s.isEnd &&
        !i.centeredSlides
      ) {
        const l = s.virtual && i.virtual.enabled ? s.virtual.slides : s.slides;
        n = s.slideTo(l.length - 1, 0, !1, !0);
      } else n = s.slideTo(s.activeIndex, 0, !1, !0);
      n || r();
    }
    (i.watchOverflow && t !== s.snapGrid && s.checkOverflow(),
      s.emit("update"));
  }
  changeDirection(s, t = !0) {
    const i = this,
      r = i.params.direction;
    return (
      s || (s = r === "horizontal" ? "vertical" : "horizontal"),
      s === r ||
        (s !== "horizontal" && s !== "vertical") ||
        (i.el.classList.remove(`${i.params.containerModifierClass}${r}`),
        i.el.classList.add(`${i.params.containerModifierClass}${s}`),
        i.emitContainerClasses(),
        (i.params.direction = s),
        i.slides.forEach((n) => {
          s === "vertical" ? (n.style.width = "") : (n.style.height = "");
        }),
        i.emit("changeDirection"),
        t && i.update()),
      i
    );
  }
  changeLanguageDirection(s) {
    const t = this;
    (t.rtl && s === "rtl") ||
      (!t.rtl && s === "ltr") ||
      ((t.rtl = s === "rtl"),
      (t.rtlTranslate = t.params.direction === "horizontal" && t.rtl),
      t.rtl
        ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`),
          (t.el.dir = "rtl"))
        : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`),
          (t.el.dir = "ltr")),
      t.update());
  }
  mount(s) {
    const t = this;
    if (t.mounted) return !0;
    let i = s || t.params.el;
    if ((typeof i == "string" && (i = document.querySelector(i)), !i))
      return !1;
    ((i.swiper = t),
      i.parentNode &&
        i.parentNode.host &&
        i.parentNode.host.nodeName ===
          t.params.swiperElementNodeName.toUpperCase() &&
        (t.isElement = !0));
    const r = () =>
      `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let l = (() =>
      i && i.shadowRoot && i.shadowRoot.querySelector
        ? i.shadowRoot.querySelector(r())
        : H(i, r())[0])();
    return (
      !l &&
        t.params.createElements &&
        ((l = U("div", t.params.wrapperClass)),
        i.append(l),
        H(i, `.${t.params.slideClass}`).forEach((o) => {
          l.append(o);
        })),
      Object.assign(t, {
        el: i,
        wrapperEl: l,
        slidesEl:
          t.isElement && !i.parentNode.host.slideSlots ? i.parentNode.host : l,
        hostEl: t.isElement ? i.parentNode.host : i,
        mounted: !0,
        rtl: i.dir.toLowerCase() === "rtl" || j(i, "direction") === "rtl",
        rtlTranslate:
          t.params.direction === "horizontal" &&
          (i.dir.toLowerCase() === "rtl" || j(i, "direction") === "rtl"),
        wrongRTL: j(l, "display") === "-webkit-box",
      }),
      !0
    );
  }
  init(s) {
    const t = this;
    if (t.initialized || t.mount(s) === !1) return t;
    (t.emit("beforeInit"),
      t.params.breakpoints && t.setBreakpoint(),
      t.addClasses(),
      t.updateSize(),
      t.updateSlides(),
      t.params.watchOverflow && t.checkOverflow(),
      t.params.grabCursor && t.enabled && t.setGrabCursor(),
      t.params.loop && t.virtual && t.params.virtual.enabled
        ? t.slideTo(
            t.params.initialSlide + t.virtual.slidesBefore,
            0,
            t.params.runCallbacksOnInit,
            !1,
            !0,
          )
        : t.slideTo(
            t.params.initialSlide,
            0,
            t.params.runCallbacksOnInit,
            !1,
            !0,
          ),
      t.params.loop && t.loopCreate(void 0, !0),
      t.attachEvents());
    const r = [...t.el.querySelectorAll('[loading="lazy"]')];
    return (
      t.isElement && r.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
      r.forEach((n) => {
        n.complete
          ? K(t, n)
          : n.addEventListener("load", (l) => {
              K(t, l.target);
            });
      }),
      de(t),
      (t.initialized = !0),
      de(t),
      t.emit("init"),
      t.emit("afterInit"),
      t
    );
  }
  destroy(s = !0, t = !0) {
    const i = this,
      { params: r, el: n, wrapperEl: l, slides: o } = i;
    return (
      typeof i.params > "u" ||
        i.destroyed ||
        (i.emit("beforeDestroy"),
        (i.initialized = !1),
        i.detachEvents(),
        r.loop && i.loopDestroy(),
        t &&
          (i.removeClasses(),
          n && typeof n != "string" && n.removeAttribute("style"),
          l && l.removeAttribute("style"),
          o &&
            o.length &&
            o.forEach((a) => {
              (a.classList.remove(
                r.slideVisibleClass,
                r.slideFullyVisibleClass,
                r.slideActiveClass,
                r.slideNextClass,
                r.slidePrevClass,
              ),
                a.removeAttribute("style"),
                a.removeAttribute("data-swiper-slide-index"));
            })),
        i.emit("destroy"),
        Object.keys(i.eventsListeners).forEach((a) => {
          i.off(a);
        }),
        s !== !1 &&
          (i.el && typeof i.el != "string" && (i.el.swiper = null), ze(i)),
        (i.destroyed = !0)),
      null
    );
  }
  static extendDefaults(s) {
    F(ae, s);
  }
  static get extendedDefaults() {
    return ae;
  }
  static get defaults() {
    return Se;
  }
  static installModule(s) {
    $.prototype.__modules__ || ($.prototype.__modules__ = []);
    const t = $.prototype.__modules__;
    typeof s == "function" && t.indexOf(s) < 0 && t.push(s);
  }
  static use(s) {
    return Array.isArray(s)
      ? (s.forEach((t) => $.installModule(t)), $)
      : ($.installModule(s), $);
  }
}
Object.keys(re).forEach((e) => {
  Object.keys(re[e]).forEach((s) => {
    $.prototype[s] = re[e][s];
  });
});
$.use([We, Ye]);
function pe(e, s, t, i) {
  return (
    e.params.createElements &&
      Object.keys(i).forEach((r) => {
        if (!t[r] && t.auto === !0) {
          let n = H(e.el, `.${i[r]}`)[0];
          (n || ((n = U("div", i[r])), (n.className = i[r]), e.el.append(n)),
            (t[r] = n),
            (s[r] = n));
        }
      }),
    t
  );
}
const ye =
  '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
function Ae({ swiper: e, extendParams: s, on: t, emit: i }) {
  (s({
    navigation: {
      nextEl: null,
      prevEl: null,
      addIcons: !0,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled",
    },
  }),
    (e.navigation = { nextEl: null, prevEl: null, arrowSvg: ye }));
  function r(d) {
    let m;
    return d &&
      typeof d == "string" &&
      e.isElement &&
      ((m = e.el.querySelector(d) || e.hostEl.querySelector(d)), m)
      ? m
      : (d &&
          (typeof d == "string" && (m = [...document.querySelectorAll(d)]),
          e.params.uniqueNavElements &&
          typeof d == "string" &&
          m &&
          m.length > 1 &&
          e.el.querySelectorAll(d).length === 1
            ? (m = e.el.querySelector(d))
            : m && m.length === 1 && (m = m[0])),
        d && !m ? d : m);
  }
  function n(d, m) {
    const b = e.params.navigation;
    ((d = D(d)),
      d.forEach((y) => {
        y &&
          (y.classList[m ? "add" : "remove"](...b.disabledClass.split(" ")),
          y.tagName === "BUTTON" && (y.disabled = m),
          e.params.watchOverflow &&
            e.enabled &&
            y.classList[e.isLocked ? "add" : "remove"](b.lockClass));
      }));
  }
  function l() {
    const { nextEl: d, prevEl: m } = e.navigation;
    if (e.params.loop) {
      (n(m, !1), n(d, !1));
      return;
    }
    (n(m, e.isBeginning && !e.params.rewind),
      n(d, e.isEnd && !e.params.rewind));
  }
  function o(d) {
    (d.preventDefault(),
      !(e.isBeginning && !e.params.loop && !e.params.rewind) &&
        (e.slidePrev(), i("navigationPrev")));
  }
  function a(d) {
    (d.preventDefault(),
      !(e.isEnd && !e.params.loop && !e.params.rewind) &&
        (e.slideNext(), i("navigationNext")));
  }
  function f() {
    const d = e.params.navigation;
    if (
      ((e.params.navigation = pe(
        e,
        e.originalParams.navigation,
        e.params.navigation,
        { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" },
      )),
      !(d.nextEl || d.prevEl))
    )
      return;
    let m = r(d.nextEl),
      b = r(d.prevEl);
    (Object.assign(e.navigation, { nextEl: m, prevEl: b }),
      (m = D(m)),
      (b = D(b)));
    const y = (u, h) => {
      if (u) {
        if (
          d.addIcons &&
          u.matches(".swiper-button-next,.swiper-button-prev") &&
          !u.querySelector("svg")
        ) {
          const v = document.createElement("div");
          (oe(v, ye), u.appendChild(v.querySelector("svg")), v.remove());
        }
        u.addEventListener("click", h === "next" ? a : o);
      }
      !e.enabled && u && u.classList.add(...d.lockClass.split(" "));
    };
    (m.forEach((u) => y(u, "next")), b.forEach((u) => y(u, "prev")));
  }
  function p() {
    let { nextEl: d, prevEl: m } = e.navigation;
    ((d = D(d)), (m = D(m)));
    const b = (y, u) => {
      (y.removeEventListener("click", u === "next" ? a : o),
        y.classList.remove(...e.params.navigation.disabledClass.split(" ")));
    };
    (d.forEach((y) => b(y, "next")), m.forEach((y) => b(y, "prev")));
  }
  (t("init", () => {
    e.params.navigation.enabled === !1 ? g() : (f(), l());
  }),
    t("toEdge fromEdge lock unlock", () => {
      l();
    }),
    t("destroy", () => {
      p();
    }),
    t("enable disable", () => {
      let { nextEl: d, prevEl: m } = e.navigation;
      if (((d = D(d)), (m = D(m)), e.enabled)) {
        l();
        return;
      }
      [...d, ...m]
        .filter((b) => !!b)
        .forEach((b) => b.classList.add(e.params.navigation.lockClass));
    }),
    t("click", (d, m) => {
      let { nextEl: b, prevEl: y } = e.navigation;
      ((b = D(b)), (y = D(y)));
      const u = m.target;
      let h = y.includes(u) || b.includes(u);
      if (e.isElement && !h) {
        const v = m.path || (m.composedPath && m.composedPath());
        v && (h = v.find((x) => b.includes(x) || y.includes(x)));
      }
      if (e.params.navigation.hideOnClick && !h) {
        if (
          e.pagination &&
          e.params.pagination &&
          e.params.pagination.clickable &&
          (e.pagination.el === u || e.pagination.el.contains(u))
        )
          return;
        let v;
        (b.length
          ? (v = b[0].classList.contains(e.params.navigation.hiddenClass))
          : y.length &&
            (v = y[0].classList.contains(e.params.navigation.hiddenClass)),
          i(v === !0 ? "navigationShow" : "navigationHide"),
          [...b, ...y]
            .filter((x) => !!x)
            .forEach((x) =>
              x.classList.toggle(e.params.navigation.hiddenClass),
            ));
      }
    }));
  const c = () => {
      (e.el.classList.remove(
        ...e.params.navigation.navigationDisabledClass.split(" "),
      ),
        f(),
        l());
    },
    g = () => {
      (e.el.classList.add(
        ...e.params.navigation.navigationDisabledClass.split(" "),
      ),
        p());
    };
  Object.assign(e.navigation, {
    enable: c,
    disable: g,
    update: l,
    init: f,
    destroy: p,
  });
}
function Y(e = "") {
  return `.${e
    .trim()
    .replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, "\\$1")
    .replace(/ /g, ".")}`;
}
function Zt({ swiper: e, extendParams: s, on: t, emit: i }) {
  const r = "swiper-pagination";
  (s({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (u) => u,
      formatFractionTotal: (u) => u,
      bulletClass: `${r}-bullet`,
      bulletActiveClass: `${r}-bullet-active`,
      modifierClass: `${r}-`,
      currentClass: `${r}-current`,
      totalClass: `${r}-total`,
      hiddenClass: `${r}-hidden`,
      progressbarFillClass: `${r}-progressbar-fill`,
      progressbarOppositeClass: `${r}-progressbar-opposite`,
      clickableClass: `${r}-clickable`,
      lockClass: `${r}-lock`,
      horizontalClass: `${r}-horizontal`,
      verticalClass: `${r}-vertical`,
      paginationDisabledClass: `${r}-disabled`,
    },
  }),
    (e.pagination = { el: null, bullets: [] }));
  let n,
    l = 0;
  function o() {
    return (
      !e.params.pagination.el ||
      !e.pagination.el ||
      (Array.isArray(e.pagination.el) && e.pagination.el.length === 0)
    );
  }
  function a(u, h) {
    const { bulletActiveClass: v } = e.params.pagination;
    u &&
      ((u = u[`${h === "prev" ? "previous" : "next"}ElementSibling`]),
      u &&
        (u.classList.add(`${v}-${h}`),
        (u = u[`${h === "prev" ? "previous" : "next"}ElementSibling`]),
        u && u.classList.add(`${v}-${h}-${h}`)));
  }
  function f(u, h, v) {
    if (((u = u % v), (h = h % v), h === u + 1)) return "next";
    if (h === u - 1) return "previous";
  }
  function p(u) {
    const h = u.target.closest(Y(e.params.pagination.bulletClass));
    if (!h) return;
    u.preventDefault();
    const v = J(h) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === v) return;
      const x = f(e.realIndex, v, e.slides.length);
      x === "next"
        ? e.slideNext()
        : x === "previous"
          ? e.slidePrev()
          : e.slideToLoop(v);
    } else e.slideTo(v);
  }
  function c() {
    const u = e.rtl,
      h = e.params.pagination;
    if (o()) return;
    let v = e.pagination.el;
    v = D(v);
    let x, L;
    const A =
        e.virtual && e.params.virtual.enabled
          ? e.virtual.slides.length
          : e.slides.length,
      O = e.params.loop
        ? Math.ceil(A / e.params.slidesPerGroup)
        : e.snapGrid.length;
    if (
      (e.params.loop
        ? ((L = e.previousRealIndex || 0),
          (x =
            e.params.slidesPerGroup > 1
              ? Math.floor(e.realIndex / e.params.slidesPerGroup)
              : e.realIndex))
        : typeof e.snapIndex < "u"
          ? ((x = e.snapIndex), (L = e.previousSnapIndex))
          : ((L = e.previousIndex || 0), (x = e.activeIndex || 0)),
      h.type === "bullets" &&
        e.pagination.bullets &&
        e.pagination.bullets.length > 0)
    ) {
      const E = e.pagination.bullets;
      let k, P, S;
      if (
        (h.dynamicBullets &&
          ((n = le(E[0], e.isHorizontal() ? "width" : "height", !0)),
          v.forEach((T) => {
            T.style[e.isHorizontal() ? "width" : "height"] =
              `${n * (h.dynamicMainBullets + 4)}px`;
          }),
          h.dynamicMainBullets > 1 &&
            L !== void 0 &&
            ((l += x - (L || 0)),
            l > h.dynamicMainBullets - 1
              ? (l = h.dynamicMainBullets - 1)
              : l < 0 && (l = 0)),
          (k = Math.max(x - l, 0)),
          (P = k + (Math.min(E.length, h.dynamicMainBullets) - 1)),
          (S = (P + k) / 2)),
        E.forEach((T) => {
          const w = [
            ...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(
              (C) => `${h.bulletActiveClass}${C}`,
            ),
          ]
            .map((C) =>
              typeof C == "string" && C.includes(" ") ? C.split(" ") : C,
            )
            .flat();
          T.classList.remove(...w);
        }),
        v.length > 1)
      )
        E.forEach((T) => {
          const w = J(T);
          (w === x
            ? T.classList.add(...h.bulletActiveClass.split(" "))
            : e.isElement && T.setAttribute("part", "bullet"),
            h.dynamicBullets &&
              (w >= k &&
                w <= P &&
                T.classList.add(...`${h.bulletActiveClass}-main`.split(" ")),
              w === k && a(T, "prev"),
              w === P && a(T, "next")));
        });
      else {
        const T = E[x];
        if (
          (T && T.classList.add(...h.bulletActiveClass.split(" ")),
          e.isElement &&
            E.forEach((w, C) => {
              w.setAttribute("part", C === x ? "bullet-active" : "bullet");
            }),
          h.dynamicBullets)
        ) {
          const w = E[k],
            C = E[P];
          for (let I = k; I <= P; I += 1)
            E[I] &&
              E[I].classList.add(...`${h.bulletActiveClass}-main`.split(" "));
          (a(w, "prev"), a(C, "next"));
        }
      }
      if (h.dynamicBullets) {
        const T = Math.min(E.length, h.dynamicMainBullets + 4),
          w = (n * T - n) / 2 - S * n,
          C = u ? "right" : "left";
        E.forEach((I) => {
          I.style[e.isHorizontal() ? C : "top"] = `${w}px`;
        });
      }
    }
    v.forEach((E, k) => {
      if (
        (h.type === "fraction" &&
          (E.querySelectorAll(Y(h.currentClass)).forEach((P) => {
            P.textContent = h.formatFractionCurrent(x + 1);
          }),
          E.querySelectorAll(Y(h.totalClass)).forEach((P) => {
            P.textContent = h.formatFractionTotal(O);
          })),
        h.type === "progressbar")
      ) {
        let P;
        h.progressbarOpposite
          ? (P = e.isHorizontal() ? "vertical" : "horizontal")
          : (P = e.isHorizontal() ? "horizontal" : "vertical");
        const S = (x + 1) / O;
        let T = 1,
          w = 1;
        (P === "horizontal" ? (T = S) : (w = S),
          E.querySelectorAll(Y(h.progressbarFillClass)).forEach((C) => {
            ((C.style.transform = `translate3d(0,0,0) scaleX(${T}) scaleY(${w})`),
              (C.style.transitionDuration = `${e.params.speed}ms`));
          }));
      }
      (h.type === "custom" && h.renderCustom
        ? (oe(E, h.renderCustom(e, x + 1, O)),
          k === 0 && i("paginationRender", E))
        : (k === 0 && i("paginationRender", E), i("paginationUpdate", E)),
        e.params.watchOverflow &&
          e.enabled &&
          E.classList[e.isLocked ? "add" : "remove"](h.lockClass));
    });
  }
  function g() {
    const u = e.params.pagination;
    if (o()) return;
    const h =
      e.virtual && e.params.virtual.enabled
        ? e.virtual.slides.length
        : e.grid && e.params.grid.rows > 1
          ? e.slides.length / Math.ceil(e.params.grid.rows)
          : e.slides.length;
    let v = e.pagination.el;
    v = D(v);
    let x = "";
    if (u.type === "bullets") {
      let L = e.params.loop
        ? Math.ceil(h / e.params.slidesPerGroup)
        : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && L > h && (L = h);
      for (let A = 0; A < L; A += 1)
        u.renderBullet
          ? (x += u.renderBullet.call(e, A, u.bulletClass))
          : (x += `<${u.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${u.bulletClass}"></${u.bulletElement}>`);
    }
    (u.type === "fraction" &&
      (u.renderFraction
        ? (x = u.renderFraction.call(e, u.currentClass, u.totalClass))
        : (x = `<span class="${u.currentClass}"></span> / <span class="${u.totalClass}"></span>`)),
      u.type === "progressbar" &&
        (u.renderProgressbar
          ? (x = u.renderProgressbar.call(e, u.progressbarFillClass))
          : (x = `<span class="${u.progressbarFillClass}"></span>`)),
      (e.pagination.bullets = []),
      v.forEach((L) => {
        (u.type !== "custom" && oe(L, x || ""),
          u.type === "bullets" &&
            e.pagination.bullets.push(...L.querySelectorAll(Y(u.bulletClass))));
      }),
      u.type !== "custom" && i("paginationRender", v[0]));
  }
  function d() {
    e.params.pagination = pe(
      e,
      e.originalParams.pagination,
      e.params.pagination,
      { el: "swiper-pagination" },
    );
    const u = e.params.pagination;
    if (!u.el) return;
    let h;
    (typeof u.el == "string" && e.isElement && (h = e.el.querySelector(u.el)),
      !h &&
        typeof u.el == "string" &&
        (h = [...document.querySelectorAll(u.el)]),
      h || (h = u.el),
      !(!h || h.length === 0) &&
        (e.params.uniqueNavElements &&
          typeof u.el == "string" &&
          Array.isArray(h) &&
          h.length > 1 &&
          ((h = [...e.el.querySelectorAll(u.el)]),
          h.length > 1 && (h = h.find((v) => we(v, ".swiper")[0] === e.el))),
        Array.isArray(h) && h.length === 1 && (h = h[0]),
        Object.assign(e.pagination, { el: h }),
        (h = D(h)),
        h.forEach((v) => {
          (u.type === "bullets" &&
            u.clickable &&
            v.classList.add(...(u.clickableClass || "").split(" ")),
            v.classList.add(u.modifierClass + u.type),
            v.classList.add(
              e.isHorizontal() ? u.horizontalClass : u.verticalClass,
            ),
            u.type === "bullets" &&
              u.dynamicBullets &&
              (v.classList.add(`${u.modifierClass}${u.type}-dynamic`),
              (l = 0),
              u.dynamicMainBullets < 1 && (u.dynamicMainBullets = 1)),
            u.type === "progressbar" &&
              u.progressbarOpposite &&
              v.classList.add(u.progressbarOppositeClass),
            u.clickable && v.addEventListener("click", p),
            e.enabled || v.classList.add(u.lockClass));
        })));
  }
  function m() {
    const u = e.params.pagination;
    if (o()) return;
    let h = e.pagination.el;
    (h &&
      ((h = D(h)),
      h.forEach((v) => {
        (v.classList.remove(u.hiddenClass),
          v.classList.remove(u.modifierClass + u.type),
          v.classList.remove(
            e.isHorizontal() ? u.horizontalClass : u.verticalClass,
          ),
          u.clickable &&
            (v.classList.remove(...(u.clickableClass || "").split(" ")),
            v.removeEventListener("click", p)));
      })),
      e.pagination.bullets &&
        e.pagination.bullets.forEach((v) =>
          v.classList.remove(...u.bulletActiveClass.split(" ")),
        ));
  }
  (t("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const u = e.params.pagination;
    let { el: h } = e.pagination;
    ((h = D(h)),
      h.forEach((v) => {
        (v.classList.remove(u.horizontalClass, u.verticalClass),
          v.classList.add(
            e.isHorizontal() ? u.horizontalClass : u.verticalClass,
          ));
      }));
  }),
    t("init", () => {
      e.params.pagination.enabled === !1 ? y() : (d(), g(), c());
    }),
    t("activeIndexChange", () => {
      typeof e.snapIndex > "u" && c();
    }),
    t("snapIndexChange", () => {
      c();
    }),
    t("snapGridLengthChange", () => {
      (g(), c());
    }),
    t("destroy", () => {
      m();
    }),
    t("enable disable", () => {
      let { el: u } = e.pagination;
      u &&
        ((u = D(u)),
        u.forEach((h) =>
          h.classList[e.enabled ? "remove" : "add"](
            e.params.pagination.lockClass,
          ),
        ));
    }),
    t("lock unlock", () => {
      c();
    }),
    t("click", (u, h) => {
      const v = h.target,
        x = D(e.pagination.el);
      if (
        e.params.pagination.el &&
        e.params.pagination.hideOnClick &&
        x &&
        x.length > 0 &&
        !v.classList.contains(e.params.pagination.bulletClass)
      ) {
        if (
          e.navigation &&
          ((e.navigation.nextEl && v === e.navigation.nextEl) ||
            (e.navigation.prevEl && v === e.navigation.prevEl))
        )
          return;
        const L = x[0].classList.contains(e.params.pagination.hiddenClass);
        (i(L === !0 ? "paginationShow" : "paginationHide"),
          x.forEach((A) =>
            A.classList.toggle(e.params.pagination.hiddenClass),
          ));
      }
    }));
  const b = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let { el: u } = e.pagination;
      (u &&
        ((u = D(u)),
        u.forEach((h) =>
          h.classList.remove(e.params.pagination.paginationDisabledClass),
        )),
        d(),
        g(),
        c());
    },
    y = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let { el: u } = e.pagination;
      (u &&
        ((u = D(u)),
        u.forEach((h) =>
          h.classList.add(e.params.pagination.paginationDisabledClass),
        )),
        m());
    };
  Object.assign(e.pagination, {
    enable: b,
    disable: y,
    render: g,
    update: c,
    init: d,
    destroy: m,
  });
}
function Jt({ swiper: e, extendParams: s, on: t, emit: i }) {
  const r = N();
  let n = !1,
    l = null,
    o = null,
    a,
    f,
    p,
    c;
  (s({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical",
    },
  }),
    (e.scrollbar = { el: null, dragEl: null }));
  function g() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const { scrollbar: S, rtlTranslate: T } = e,
      { dragEl: w, el: C } = S,
      I = e.params.scrollbar,
      z = e.params.loop ? e.progressLoop : e.progress;
    let _ = f,
      M = (p - f) * z;
    (T
      ? ((M = -M), M > 0 ? ((_ = f - M), (M = 0)) : -M + f > p && (_ = p + M))
      : M < 0
        ? ((_ = f + M), (M = 0))
        : M + f > p && (_ = p - M),
      e.isHorizontal()
        ? ((w.style.transform = `translate3d(${M}px, 0, 0)`),
          (w.style.width = `${_}px`))
        : ((w.style.transform = `translate3d(0px, ${M}px, 0)`),
          (w.style.height = `${_}px`)),
      I.hide &&
        (clearTimeout(l),
        (C.style.opacity = 1),
        (l = setTimeout(() => {
          ((C.style.opacity = 0), (C.style.transitionDuration = "400ms"));
        }, 1e3))));
  }
  function d(S) {
    !e.params.scrollbar.el ||
      !e.scrollbar.el ||
      (e.scrollbar.dragEl.style.transitionDuration = `${S}ms`);
  }
  function m() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const { scrollbar: S } = e,
      { dragEl: T, el: w } = S;
    ((T.style.width = ""),
      (T.style.height = ""),
      (p = e.isHorizontal() ? w.offsetWidth : w.offsetHeight),
      (c =
        e.size /
        (e.virtualSize +
          e.params.slidesOffsetBefore -
          (e.params.centeredSlides ? e.snapGrid[0] : 0))),
      e.params.scrollbar.dragSize === "auto"
        ? (f = p * c)
        : (f = parseInt(e.params.scrollbar.dragSize, 10)),
      e.isHorizontal()
        ? (T.style.width = `${f}px`)
        : (T.style.height = `${f}px`),
      c >= 1 ? (w.style.display = "none") : (w.style.display = ""),
      e.params.scrollbar.hide && (w.style.opacity = 0),
      e.params.watchOverflow &&
        e.enabled &&
        S.el.classList[e.isLocked ? "add" : "remove"](
          e.params.scrollbar.lockClass,
        ));
  }
  function b(S) {
    return e.isHorizontal() ? S.clientX : S.clientY;
  }
  function y(S) {
    const { scrollbar: T, rtlTranslate: w } = e,
      { el: C } = T;
    let I;
    ((I =
      (b(S) -
        $e(C)[e.isHorizontal() ? "left" : "top"] -
        (a !== null ? a : f / 2)) /
      (p - f)),
      (I = Math.max(Math.min(I, 1), 0)),
      w && (I = 1 - I));
    const z = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * I;
    (e.updateProgress(z),
      e.setTranslate(z),
      e.updateActiveIndex(),
      e.updateSlidesClasses());
  }
  function u(S) {
    const T = e.params.scrollbar,
      { scrollbar: w, wrapperEl: C } = e,
      { el: I, dragEl: z } = w;
    ((n = !0),
      (a =
        S.target === z
          ? b(S) -
            S.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"]
          : null),
      S.preventDefault(),
      S.stopPropagation(),
      (C.style.transitionDuration = "100ms"),
      (z.style.transitionDuration = "100ms"),
      y(S),
      clearTimeout(o),
      (I.style.transitionDuration = "0ms"),
      T.hide && (I.style.opacity = 1),
      e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"),
      i("scrollbarDragStart", S));
  }
  function h(S) {
    const { scrollbar: T, wrapperEl: w } = e,
      { el: C, dragEl: I } = T;
    n &&
      (S.preventDefault && S.cancelable
        ? S.preventDefault()
        : (S.returnValue = !1),
      y(S),
      (w.style.transitionDuration = "0ms"),
      (C.style.transitionDuration = "0ms"),
      (I.style.transitionDuration = "0ms"),
      i("scrollbarDragMove", S));
  }
  function v(S) {
    const T = e.params.scrollbar,
      { scrollbar: w, wrapperEl: C } = e,
      { el: I } = w;
    n &&
      ((n = !1),
      e.params.cssMode &&
        ((e.wrapperEl.style["scroll-snap-type"] = ""),
        (C.style.transitionDuration = "")),
      T.hide &&
        (clearTimeout(o),
        (o = ue(() => {
          ((I.style.opacity = 0), (I.style.transitionDuration = "400ms"));
        }, 1e3))),
      i("scrollbarDragEnd", S),
      T.snapOnRelease && e.slideToClosest());
  }
  function x(S) {
    const { scrollbar: T, params: w } = e,
      C = T.el;
    if (!C) return;
    const I = C,
      z = w.passiveListeners ? { passive: !1, capture: !1 } : !1,
      _ = w.passiveListeners ? { passive: !0, capture: !1 } : !1;
    if (!I) return;
    const M = S === "on" ? "addEventListener" : "removeEventListener";
    (I[M]("pointerdown", u, z),
      r[M]("pointermove", h, z),
      r[M]("pointerup", v, _));
  }
  function L() {
    !e.params.scrollbar.el || !e.scrollbar.el || x("on");
  }
  function A() {
    !e.params.scrollbar.el || !e.scrollbar.el || x("off");
  }
  function O() {
    const { scrollbar: S, el: T } = e;
    e.params.scrollbar = pe(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar",
    });
    const w = e.params.scrollbar;
    if (!w.el) return;
    let C;
    if (
      (typeof w.el == "string" && e.isElement && (C = e.el.querySelector(w.el)),
      !C && typeof w.el == "string")
    ) {
      if (((C = r.querySelectorAll(w.el)), !C.length)) return;
    } else C || (C = w.el);
    (e.params.uniqueNavElements &&
      typeof w.el == "string" &&
      C.length > 1 &&
      T.querySelectorAll(w.el).length === 1 &&
      (C = T.querySelector(w.el)),
      C.length > 0 && (C = C[0]),
      C.classList.add(e.isHorizontal() ? w.horizontalClass : w.verticalClass));
    let I;
    (C &&
      ((I = C.querySelector(Y(e.params.scrollbar.dragClass))),
      I || ((I = U("div", e.params.scrollbar.dragClass)), C.append(I))),
      Object.assign(S, { el: C, dragEl: I }),
      w.draggable && L(),
      C &&
        C.classList[e.enabled ? "remove" : "add"](
          ...R(e.params.scrollbar.lockClass),
        ));
  }
  function E() {
    const S = e.params.scrollbar,
      T = e.scrollbar.el;
    (T &&
      T.classList.remove(
        ...R(e.isHorizontal() ? S.horizontalClass : S.verticalClass),
      ),
      A());
  }
  (t("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const S = e.params.scrollbar;
    let { el: T } = e.scrollbar;
    ((T = D(T)),
      T.forEach((w) => {
        (w.classList.remove(S.horizontalClass, S.verticalClass),
          w.classList.add(
            e.isHorizontal() ? S.horizontalClass : S.verticalClass,
          ));
      }));
  }),
    t("init", () => {
      e.params.scrollbar.enabled === !1 ? P() : (O(), m(), g());
    }),
    t("update resize observerUpdate lock unlock changeDirection", () => {
      m();
    }),
    t("setTranslate", () => {
      g();
    }),
    t("setTransition", (S, T) => {
      d(T);
    }),
    t("enable disable", () => {
      const { el: S } = e.scrollbar;
      S &&
        S.classList[e.enabled ? "remove" : "add"](
          ...R(e.params.scrollbar.lockClass),
        );
    }),
    t("destroy", () => {
      E();
    }));
  const k = () => {
      (e.el.classList.remove(...R(e.params.scrollbar.scrollbarDisabledClass)),
        e.scrollbar.el &&
          e.scrollbar.el.classList.remove(
            ...R(e.params.scrollbar.scrollbarDisabledClass),
          ),
        O(),
        m(),
        g());
    },
    P = () => {
      (e.el.classList.add(...R(e.params.scrollbar.scrollbarDisabledClass)),
        e.scrollbar.el &&
          e.scrollbar.el.classList.add(
            ...R(e.params.scrollbar.scrollbarDisabledClass),
          ),
        E());
    };
  Object.assign(e.scrollbar, {
    enable: k,
    disable: P,
    updateSize: m,
    setTranslate: g,
    init: O,
    destroy: E,
  });
}
function es({ swiper: e, extendParams: s, on: t }) {
  s({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs",
    },
  });
  let i = !1,
    r = !1;
  e.thumbs = { swiper: null };
  function n() {
    const p = e.thumbs.swiper;
    return !p || p.destroyed
      ? !1
      : p.params.virtual && p.params.virtual.enabled;
  }
  function l() {
    const p = e.thumbs.swiper;
    if (!p || p.destroyed) return;
    const c = p.clickedIndex,
      g = p.clickedSlide;
    if (
      (g && g.classList.contains(e.params.thumbs.slideThumbActiveClass)) ||
      typeof c > "u" ||
      c === null
    )
      return;
    let d;
    (p.params.loop
      ? (d = parseInt(
          p.clickedSlide.getAttribute("data-swiper-slide-index"),
          10,
        ))
      : (d = c),
      e.params.loop ? e.slideToLoop(d) : e.slideTo(d));
  }
  function o() {
    const { thumbs: p } = e.params;
    if (i) return !1;
    i = !0;
    const c = e.constructor;
    if (p.swiper instanceof c) {
      if (p.swiper.destroyed) return ((i = !1), !1);
      ((e.thumbs.swiper = p.swiper),
        Object.assign(e.thumbs.swiper.originalParams, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        Object.assign(e.thumbs.swiper.params, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        e.thumbs.swiper.update());
    } else if (X(p.swiper)) {
      const g = Object.assign({}, p.swiper);
      (Object.assign(g, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
        (e.thumbs.swiper = new c(g)),
        (r = !0));
    }
    return (
      e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass),
      e.thumbs.swiper.on("tap", l),
      n() &&
        e.thumbs.swiper.on("virtualUpdate", () => {
          a(!1, { autoScroll: !1 });
        }),
      !0
    );
  }
  function a(p, c) {
    const g = e.thumbs.swiper;
    if (!g || g.destroyed) return;
    let d = 1;
    const m = e.params.thumbs.slideThumbActiveClass;
    if (
      (e.params.slidesPerView > 1 &&
        !e.params.centeredSlides &&
        (d = e.params.slidesPerView),
      e.params.thumbs.multipleActiveThumbs || (d = 1),
      (d = Math.floor(d)),
      g.slides.forEach((b) => b.classList.remove(m)),
      g.params.loop || n())
    )
      for (let b = 0; b < d; b += 1)
        H(g.slidesEl, `[data-swiper-slide-index="${e.realIndex + b}"]`).forEach(
          (y) => {
            y.classList.add(m);
          },
        );
    else
      for (let b = 0; b < d; b += 1)
        g.slides[e.realIndex + b] && g.slides[e.realIndex + b].classList.add(m);
    ((c == null ? void 0 : c.autoScroll) ?? !0) && f(p ? 0 : void 0);
  }
  function f(p) {
    const c = e.thumbs.swiper;
    if (!c || c.destroyed) return;
    const g =
        c.params.slidesPerView === "auto"
          ? c.slidesPerViewDynamic()
          : c.params.slidesPerView,
      d = e.params.thumbs.autoScrollOffset,
      m = d && !c.params.loop;
    if (e.realIndex !== c.realIndex || m) {
      const b = c.activeIndex;
      let y, u;
      if (c.params.loop) {
        const h = c.slides.find(
          (v) => v.getAttribute("data-swiper-slide-index") === `${e.realIndex}`,
        );
        ((y = c.slides.indexOf(h)),
          (u = e.activeIndex > e.previousIndex ? "next" : "prev"));
      } else ((y = e.realIndex), (u = y > e.previousIndex ? "next" : "prev"));
      (m && (y += u === "next" ? d : -1 * d),
        c.visibleSlidesIndexes &&
          c.visibleSlidesIndexes.indexOf(y) < 0 &&
          (c.params.centeredSlides
            ? y > b
              ? (y = y - Math.floor(g / 2) + 1)
              : (y = y + Math.floor(g / 2) - 1)
            : y > b && c.params.slidesPerGroup,
          c.slideTo(y, p)));
    }
  }
  (t("beforeInit", () => {
    const { thumbs: p } = e.params;
    if (!(!p || !p.swiper))
      if (typeof p.swiper == "string" || p.swiper instanceof HTMLElement) {
        const c = N(),
          g = () => {
            const m =
              typeof p.swiper == "string"
                ? c.querySelector(p.swiper)
                : p.swiper;
            if (m && m.swiper) ((p.swiper = m.swiper), o(), a(!0));
            else if (m) {
              const b = `${e.params.eventsPrefix}init`,
                y = (u) => {
                  ((p.swiper = u.detail[0]),
                    m.removeEventListener(b, y),
                    o(),
                    a(!0),
                    p.swiper.update(),
                    e.update());
                };
              m.addEventListener(b, y);
            }
            return m;
          },
          d = () => {
            if (e.destroyed) return;
            g() || requestAnimationFrame(d);
          };
        requestAnimationFrame(d);
      } else (o(), a(!0));
  }),
    t("slideChange update resize observerUpdate", () => {
      a();
    }),
    t("setTransition", (p, c) => {
      const g = e.thumbs.swiper;
      !g || g.destroyed || g.setTransition(c);
    }),
    t("beforeDestroy", () => {
      const p = e.thumbs.swiper;
      !p || p.destroyed || (r && p.destroy());
    }),
    Object.assign(e.thumbs, { init: o, update: a }));
}
function ts(e) {
  const {
    effect: s,
    swiper: t,
    on: i,
    setTranslate: r,
    setTransition: n,
    overwriteParams: l,
    perspective: o,
    recreateShadows: a,
    getEffectParams: f,
  } = e;
  (i("beforeInit", () => {
    if (t.params.effect !== s) return;
    (t.classNames.push(`${t.params.containerModifierClass}${s}`),
      o && o() && t.classNames.push(`${t.params.containerModifierClass}3d`));
    const c = l ? l() : {};
    (Object.assign(t.params, c), Object.assign(t.originalParams, c));
  }),
    i("setTranslate _virtualUpdated", () => {
      t.params.effect === s && r();
    }),
    i("setTransition", (c, g) => {
      t.params.effect === s && n(g);
    }),
    i("transitionEnd", () => {
      if (t.params.effect === s && a) {
        if (!f || !f().slideShadows) return;
        (t.slides.forEach((c) => {
          c.querySelectorAll(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left",
          ).forEach((g) => g.remove());
        }),
          a());
      }
    }));
  let p;
  i("virtualUpdate", () => {
    t.params.effect === s &&
      (t.slides.length || (p = !0),
      requestAnimationFrame(() => {
        p && t.slides && t.slides.length && (r(), (p = !1));
      }));
  });
}
function ss(e, s) {
  const t = Ee(s);
  return (
    t !== s &&
      ((t.style.backfaceVisibility = "hidden"),
      (t.style["-webkit-backface-visibility"] = "hidden")),
    t
  );
}
function is({ swiper: e, duration: s, transformElements: t, allSlides: i }) {
  const { activeIndex: r } = e,
    n = (l) =>
      l.parentElement
        ? l.parentElement
        : e.slides.find((a) => a.shadowRoot && a.shadowRoot === l.parentNode);
  if (e.params.virtualTranslate && s !== 0) {
    let l = !1,
      o;
    (i
      ? (o = t)
      : (o = t.filter((a) => {
          const f = a.classList.contains("swiper-slide-transform") ? n(a) : a;
          return e.getSlideIndex(f) === r;
        })),
      o.forEach((a) => {
        Ne(a, () => {
          if (l || !e || e.destroyed) return;
          ((l = !0), (e.animating = !1));
          const f = new window.CustomEvent("transitionend", {
            bubbles: !0,
            cancelable: !0,
          });
          e.wrapperEl.dispatchEvent(f);
        });
      }));
  }
}
function ns({ swiper: e, extendParams: s, on: t }) {
  (s({ fadeEffect: { crossFade: !1 } }),
    ts({
      effect: "fade",
      swiper: e,
      on: t,
      setTranslate: () => {
        const { slides: n } = e,
          l = e.params.fadeEffect;
        for (let o = 0; o < n.length; o += 1) {
          const a = e.slides[o];
          let p = -a.swiperSlideOffset;
          e.params.virtualTranslate || (p -= e.translate);
          let c = 0;
          e.isHorizontal() || ((c = p), (p = 0));
          const g = e.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(a.progress), 0)
              : 1 + Math.min(Math.max(a.progress, -1), 0),
            d = ss(l, a);
          ((d.style.opacity = g),
            (d.style.transform = `translate3d(${p}px, ${c}px, 0px)`));
        }
      },
      setTransition: (n) => {
        const l = e.slides.map((o) => Ee(o));
        (l.forEach((o) => {
          o.style.transitionDuration = `${n}ms`;
        }),
          is({ swiper: e, duration: n, transformElements: l, allSlides: !0 }));
      },
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !e.params.cssMode,
      }),
    }));
}
let ce = (e, s = 500) => {
    e.classList.contains("_slide") ||
      (e.classList.add("_slide"),
      (e.style.transitionProperty = "height, margin, padding"),
      (e.style.transitionDuration = s + "ms"),
      (e.style.height = `${e.offsetHeight}px`),
      e.offsetHeight,
      (e.style.overflow = "hidden"),
      (e.style.height = "0px"),
      (e.style.paddingTop = 0),
      (e.style.paddingBottom = 0),
      (e.style.marginTop = 0),
      (e.style.marginBottom = 0),
      window.setTimeout(() => {
        ((e.hidden = !0),
          e.style.removeProperty("height"),
          e.style.removeProperty("padding-top"),
          e.style.removeProperty("padding-bottom"),
          e.style.removeProperty("margin-top"),
          e.style.removeProperty("margin-bottom"),
          e.style.removeProperty("overflow"),
          e.style.removeProperty("transition-duration"),
          e.style.removeProperty("transition-property"),
          e.classList.remove("_slide"),
          document.dispatchEvent(
            new CustomEvent("slideUpDone", { detail: { target: e } }),
          ));
      }, s));
  },
  rs = (e, s = 500) => {
    if (!e.classList.contains("_slide")) {
      (e.classList.add("_slide"), (e.hidden = !1));
      const t = e.offsetHeight;
      ((e.style.overflow = "hidden"),
        (e.style.height = "0px"),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        e.offsetHeight,
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = s + "ms"),
        (e.style.height = `${t}px`),
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout(() => {
          (e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property"),
            e.classList.remove("_slide"),
            document.dispatchEvent(
              new CustomEvent("slideDownDone", { detail: { target: e } }),
            ));
        }, s));
    }
  },
  as = (e, s = 500) => (e.hidden ? rs(e, s) : ce(e, s));
function ls() {
  const e = document.querySelectorAll("[data-spollers]");
  if (e.length > 0) {
    let l = function (p, c = !1) {
        p.forEach((g) => {
          ((g = c ? g.item : g),
            c.matches || !c
              ? (g.classList.add("_spoller-init"), o(g))
              : (g.classList.remove("_spoller-init"), o(g, !1)));
        });
      },
      o = function (p, c = !0) {
        let g = p.querySelectorAll("details");
        g.length &&
          ((g = Array.from(g).filter(
            (d) => d.closest("[data-spollers]") === p,
          )),
          g.forEach((d) => {
            let m = d.querySelector("summary");
            c
              ? (m.removeAttribute("tabindex"),
                d.hasAttribute("data-open")
                  ? (m.classList.add("_spoller-active"), (d.open = !0))
                  : ((d.open = !1), (m.nextElementSibling.hidden = !0)))
              : (m.setAttribute("tabindex", "-1"),
                m.classList.remove("_spoller-active"),
                (d.open = !0),
                (m.nextElementSibling.hidden = !1));
          }));
      },
      a = function (p) {
        const c = p.target;
        if (c.closest(".spollers")) {
          if (
            (p.preventDefault(),
            c.closest("summary") &&
              c.closest("[data-spollers]") &&
              c.closest("[data-spollers]").classList.contains("_spoller-init"))
          ) {
            const g = c.closest("summary"),
              d = g.closest("details"),
              m = g.closest("[data-spollers]"),
              b = m.hasAttribute("data-one-spoller"),
              y = m.dataset.spollersSpeed
                ? parseInt(m.dataset.spollersSpeed)
                : 500;
            m.querySelectorAll("._slide").length ||
              (b && !d.open && f(m),
              d.open
                ? setTimeout(() => {
                    d.open = !1;
                  }, y)
                : (d.open = !0),
              g.classList.toggle("_spoller-active"),
              as(g.nextElementSibling, y));
          }
          if (!c.closest("[data-spollers]")) {
            const g = document.querySelectorAll("[data-spoller-close]");
            g.length &&
              g.forEach((d) => {
                const m = d.closest("[data-spollers]"),
                  b = d.parentNode;
                if (m.classList.contains("_spoller-init")) {
                  const y = m.dataset.spollersSpeed
                    ? parseInt(m.dataset.spollersSpeed)
                    : 500;
                  (d.classList.remove("_spoller-active"),
                    ce(d.nextElementSibling, y),
                    setTimeout(() => {
                      b.open = !1;
                    }, y));
                }
              });
          }
        }
      },
      f = function (p) {
        const c = p.querySelector("details[open]");
        if (c && !p.querySelectorAll("._slide").length) {
          const g = c.querySelector("summary"),
            d = p.dataset.spollersSpeed
              ? parseInt(p.dataset.spollersSpeed)
              : 500;
          (g.classList.remove("_spoller-active"),
            ce(g.nextElementSibling, d),
            setTimeout(() => {
              c.open = !1;
            }, d));
        }
      };
    var s = l,
      t = o,
      i = a,
      r = f;
    document.addEventListener("click", a);
    const n = Array.from(e).filter((p) => !p.dataset.spollers.split(",")[0]);
    n.length && l(n);
  }
}
document.addEventListener("DOMContentLoaded", () => {
  (ls(), fs(), ds(), cs(), os(), ps(), hs());
});
function os() {
  const e = document.querySelector(".sr-header");
  if (!e) return;
  const s = () => e.classList.toggle("sr-header--scrolled", window.scrollY > 0);
  (s(), window.addEventListener("scroll", s, { passive: !0 }));
}
function hs() {
  const e = document.querySelector(".sr-header");
  if (!e) return;
  const t = e.querySelector(".sr-header__burger");
  if (!t) return;
  t.addEventListener("click", () => {
    e.classList.toggle("sr-header--open");
    document.body.style.overflow = e.classList.contains("sr-header--open") ? "hidden" : "";
  });
  e.querySelectorAll(".sr-header__nav-link").forEach((l) => {
    l.addEventListener("click", () => {
      e.classList.remove("sr-header--open");
      document.body.style.overflow = "";
    });
  });
}
function ds() {
  const e = document.querySelector("[data-rebounds]");
  if (!e) return;
  const s = e.querySelectorAll("[data-rebounds-dot]"),
    t = e.querySelectorAll("[data-rebounds-stage]"),
    i = e.querySelector("[data-rebounds-label] p");
  s.forEach((r) => {
    r.addEventListener("click", () => {
      (s.forEach((l) => l.classList.remove("rebounds__indicator-dot--active")),
        r.classList.add("rebounds__indicator-dot--active"),
        (i.innerHTML = r.dataset.label.replace(
          `
`,
          "<br>",
        )),
        t.forEach((l) => l.classList.remove("rebounds__col-right--active")));
      const n = e.querySelector(`[data-rebounds-stage="${r.dataset.stage}"]`);
      n && n.classList.add("rebounds__col-right--active");
    });
  });
}
function cs() {
  const e = document.querySelector("[data-product-thumbs]"),
    s = document.querySelector("[data-product-main]");
  if (!e || !s) return;
  const t = new $(e, {
    modules: [Ae],
    slidesPerView: 5,
    spaceBetween: 8,
    breakpoints: {
      0: { slidesPerView: 2.4, spaceBetween: 8 },
      768: { slidesPerView: 5, spaceBetween: 8 },
    },
    navigation: { prevEl: ".product__prev", nextEl: ".product__next" },
    watchSlidesProgress: !0,
  });
  new $(s, {
    modules: [es, Zt],
    thumbs: { swiper: t },
    pagination: { el: ".product__pagination", clickable: !0 },
  });
}
function fs() {
  const e = document.querySelector("[data-howto-slider]");
  e &&
    new $(e, {
      modules: [Ae, Jt, ns],
      effect: "fade",
      fadeEffect: { crossFade: !0 },
      navigation: { prevEl: ".howto__prev", nextEl: ".howto__next" },
      scrollbar: { el: ".howto__scrollbar", draggable: !0 },
    });
}
function ps() {
  document.querySelectorAll("[data-sr-ba-slider]").forEach((e) => {
    const s = e.closest(".sr-ba-slider__slider-wrap");
    const swiper = new $(e, {
      modules: [Ae],
      slidesPerView: 1,
      spaceBetween: 24,
      touchStartPreventDefault: false,
      passiveListeners: false,
      navigation: {
        prevEl: s ? s.querySelector(".sr-ba-slider__prev") : null,
        nextEl: s ? s.querySelector(".sr-ba-slider__next") : null,
      },
    });

    e.querySelectorAll("[data-ba]").forEach((ba) => {
      const before = ba.querySelector(".sr-ba-slider__ba-before");
      const beforeImg = before ? before.querySelector("img") : null;
      const divider = ba.querySelector("[data-ba-divider]");
      if (!before || !divider) return;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        before.style.width = pct + "%";
        if (beforeImg) beforeImg.style.width = ba.offsetWidth + "px";
        divider.style.left = pct + "%";
      }

      setPos(50);
      if (beforeImg) beforeImg.addEventListener("load", () => setPos(parseFloat(before.style.width) || 50));
      window.addEventListener("resize", () => setPos(parseFloat(before.style.width) || 50));

      let dragging = false;
      const getX = (ev) => (ev.touches ? ev.touches[0].clientX : ev.clientX);
      const onMove = (ev) => {
        if (!dragging) return;
        const rect = ba.getBoundingClientRect();
        setPos(((getX(ev) - rect.left) / rect.width) * 100);
      };

      ba.addEventListener("mousedown", (ev) => {
        dragging = true;
        swiper.allowTouchMove = false;
        ev.preventDefault();
        ev.stopPropagation();
      });
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", () => { dragging = false; swiper.allowTouchMove = true; });

      ba.addEventListener("touchstart", (ev) => {
        dragging = true;
        swiper.allowTouchMove = false;
        ev.stopPropagation();
      }, { passive: true });
      document.addEventListener("touchmove", onMove, { passive: true });
      document.addEventListener("touchend", () => { dragging = false; swiper.allowTouchMove = true; });
    });
  });
}
